"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[59056],{

/***/ 7370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export ReactComponent */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function SvgBlocks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 20,
    fill: "#F05537"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.11 36.023a5.022 5.022 0 100-10.044 5.022 5.022 0 000 10.044z",
    fill: "#FEF0AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.132 31.002a5.021 5.021 0 01-8.605 3.517 5.021 5.021 0 006.06-7.887 5.02 5.02 0 012.545 4.37z",
    fill: "#FEE45A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.047 24.045h-4.755a3.482 3.482 0 01-3.482-3.482v-3.128a3.482 3.482 0 013.482-3.482h3.128a3.482 3.482 0 013.482 3.482v4.756c0 1.024-.83 1.854-1.855 1.854zM32.674 24.045H27.92a1.855 1.855 0 01-1.855-1.854v-4.756a3.482 3.482 0 013.483-3.482h3.127a3.482 3.482 0 013.483 3.482v3.128a3.482 3.482 0 01-3.483 3.482zM20.419 36.047h-3.128a3.482 3.482 0 01-3.482-3.482v-3.128a3.482 3.482 0 013.482-3.482h4.756c1.024 0 1.854.83 1.854 1.855v4.755a3.482 3.482 0 01-3.482 3.482z",
    fill: "#94DFB6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.901 17.435v4.755c0 1.024-.83 1.855-1.855 1.855h-1.213c1.024 0 1.855-.83 1.855-1.855v-4.755a3.482 3.482 0 00-3.483-3.482h1.214a3.482 3.482 0 013.482 3.482zM36.157 17.435v3.128a3.482 3.482 0 01-3.482 3.482H31.46a3.482 3.482 0 003.482-3.482v-3.128a3.482 3.482 0 00-3.482-3.482h1.214a3.482 3.482 0 013.482 3.482zM23.901 27.81v4.755a3.482 3.482 0 01-3.482 3.482h-1.214a3.482 3.482 0 003.483-3.482V27.81c0-1.024-.831-1.855-1.855-1.855h1.213c1.025 0 1.855.83 1.855 1.855z",
    fill: "#73D3A3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.788 30.573a17.814 17.814 0 01-.289-.104V28.84c.221.067.35.177.358.183l.009.009.202.175a.422.422 0 10.553-.637l-.202-.176a1.97 1.97 0 00-.92-.42v-.308a.422.422 0 10-.843 0v.34a1.55 1.55 0 00-1.19 1.25c-.102.536.07 1.054.45 1.351.19.149.423.285.74.428v2.109c-.255-.026-.431-.1-.719-.288a.422.422 0 10-.462.707c.461.301.782.399 1.18.427v.347a.422.422 0 00.844 0v-.385c.793-.182 1.302-.85 1.412-1.51.142-.843-.299-1.577-1.123-1.869zm-1.35-.63c-.13-.1-.185-.31-.144-.53a.74.74 0 01.361-.517v1.193a1.935 1.935 0 01-.218-.146zm1.641 2.36c-.05.297-.247.612-.58.763v-1.7l.008.003c.638.226.6.772.572.933z",
    fill: "#FAC600"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.116 11.11c-.201.467-.618 1.155-1.416 1.53a.18.18 0 000 .326c.798.376 1.215 1.064 1.416 1.531a.18.18 0 00.331 0c.202-.467.619-1.155 1.417-1.531a.18.18 0 000-.325c-.798-.376-1.215-1.064-1.416-1.532a.18.18 0 00-.332 0z",
    fill: "#FEF0AE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.864 12.966c-.797.375-1.214 1.063-1.416 1.53a.18.18 0 01-.331 0 3.312 3.312 0 00-.49-.805c.222-.493.662-1.183 1.476-1.567a.094.094 0 00.017-.01c.2.2.446.386.745.526a.18.18 0 010 .325z",
    fill: "#FEE45A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.52 35.503c-.202.467-.62 1.155-1.417 1.531a.18.18 0 000 .325c.798.377 1.215 1.064 1.417 1.532a.18.18 0 00.33 0c.202-.468.62-1.156 1.417-1.532a.18.18 0 000-.325c-.798-.376-1.215-1.064-1.416-1.531a.18.18 0 00-.332 0z",
    fill: "#FEF0AE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.267 37.36c-.798.376-1.215 1.064-1.416 1.531a.18.18 0 01-.332 0 3.31 3.31 0 00-.49-.806c.223-.492.662-1.182 1.476-1.566a.086.086 0 00.017-.01c.2.2.446.385.745.526a.18.18 0 010 .325z",
    fill: "#FEE45A"
  })));
}
/* harmony default export */ __webpack_exports__["Z"] = ("/_next/static/media/blocks.79fdde7d124dc15212fbd6970afdb023.svg");


/***/ }),

/***/ 50706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("/_next/static/media/Nordic Flowers.187f943c769765d07f4814c5c310faab.jpeg");

/***/ }),

/***/ 82750:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("/_next/static/media/Organic Africa's Veg.177639e36c66b962e5510df6101a8bc7.jpg");

/***/ }),

/***/ 71643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("/_next/static/media/Turkish Dried Fruits.02b9a2a199cf158481057e5dd933b745.jpeg");

/***/ }),

/***/ 98634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("/_next/static/media/Yemen coffee.c6058e89d8537ccc9c03db9f2074d9b7.jpeg");

/***/ }),

/***/ 49609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("/_next/static/media/account1.d513d9afa8f16fcbd89e3ad8b4b30a60.png");

/***/ }),

/***/ 16162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("/_next/static/media/nordic design.9587aa1e7c433ca4792780eba1358880.jpg");

/***/ }),

/***/ 24759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("/_next/static/media/productconference.d690dd72e10e8fd6a7567edb608bf2b7.jpg");

/***/ }),

/***/ 41678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ Editor; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./src/components/TabBar.js


function TabBar(param) {
    var primary = param.primary, _secondary = param.secondary, secondary = _secondary === void 0 ? [] : _secondary, _showTabMarkers = param.showTabMarkers, showTabMarkers = _showTabMarkers === void 0 ? true : _showTabMarkers, side = param.side, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex text-gray-400 text-xs leading-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-none text-sky-300 border-t border-b border-t-transparent border-b-sky-300 px-4 py-1 flex items-center",
                children: [
                    primary.name,
                    showTabMarkers && (primary.saved ? /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        viewBox: "0 0 4 4",
                        className: "ml-2.5 flex-none w-1 h-1 text-gray-500 overflow-visible",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M-1 -1L5 5M5 -1L-1 5",
                            fill: "none",
                            stroke: "currentColor",
                            strokeLinecap: "round"
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "ml-2.5 flex-none w-1 h-1 rounded-full bg-current"
                    }))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)("flex-auto flex items-center bg-gray-700/50 border border-gray-500/30", side === "left" ? "rounded-tl lg:rounded-tr" : "rounded-tl"),
                children: [
                    secondary.map(function(param) {
                        var name = param.name, _open = param.open, open = _open === void 0 ? true : _open, className = param.className;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,clsx_m/* default */.Z)("px-4 py-1 border-r border-gray-200/5", className, {
                                italic: !open
                            }),
                            children: name
                        }, name);
                    }),
                    children && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-auto flex items-center justify-end px-4 space-x-4",
                        children: children
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Editor.js


function Editor(param) {
    var filename = param.filename, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-5 mb-8 first:mt-0 last:mb-0 pt-2 bg-gray-800 rounded-xl shadow-lg overflow-hidden",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabBar, {
                primary: {
                    name: filename
                },
                showTabMarkers: false
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "children:my-0",
                children: children
            })
        ]
    });
}


/***/ }),

/***/ 49289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": function() { return /* binding */ Steps; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/redent/index.js
var redent = __webpack_require__(82931);
var redent_default = /*#__PURE__*/__webpack_require__.n(redent);
// EXTERNAL MODULE: ./node_modules/@reach/alert/dist/reach-alert.esm.js + 6 modules
var reach_alert_esm = __webpack_require__(95877);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/tabs/tabs.esm.js
var tabs_esm = __webpack_require__(66311);
;// CONCATENATED MODULE: ./src/components/SnippetGroup.js




/**
 * @typedef {React.ReactElement<{ filename?: string }>} CodeBlock
 */ /**
 * Handles styling for a specific ui affordance inside a tab
 *
 * @param {object} props
 * @param {import('clsx').ClassValue} props.className
 */ function TabAdornment(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)("pointer-events-none absolute inset-0", className)
    });
}
/**
 * Represents a styled tab in a snippet group that adjusts its style
 * based on the position of this tab relative to the selected tab(s)
 *
 * Also supports an optional marker icon (close or modified)
 *
 * @param {object} props
 * @param {ReactElement[]} props.children
 * @param {number} props.selectedIndex
 * @param {number} props.myIndex
 * @param {"close" | "modified"} [props.marker]
 */ function TabItem(param) {
    var children = param.children, selectedIndex = param.selectedIndex, myIndex = param.myIndex, marker = param.marker;
    var isSelected = selectedIndex === myIndex;
    var isBeforeSelected = selectedIndex === myIndex + 1;
    var isAfterSelected = selectedIndex === myIndex - 1;
    // A cap is the edge of a list of tabs that has a special border treatment
    // The edges of a tab may be in one of three states:
    // - null if selected
    // - normal if it looks like a normal tab
    // - capped if there's a solid rounded corner on that edge
    var edges = {
        leading: isSelected ? null : isAfterSelected ? "capped" : "normal",
        trailing: isSelected ? null : isBeforeSelected ? "capped" : "normal"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs_esm/* Tab */.O, {
        className: (0,clsx_m/* default */.Z)("flex items-center relative z-10 overflow-hidden px-4 py-1", isSelected ? "text-sky-300" : "text-gray-400"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "z-10",
                children: children
            }),
            marker === "close" && /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                viewBox: "0 0 4 4",
                className: "ml-2.5 flex-none w-1 h-1 text-gray-500 overflow-visible",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M-1 -1L5 5M5 -1L-1 5",
                    fill: "none",
                    stroke: "currentColor",
                    strokeLinecap: "round"
                })
            }),
            marker === "modified" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "ml-2.5 flex-none w-1 h-1 rounded-full bg-current"
            }),
            !isSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)(TabAdornment, {
                className: (0,clsx_m/* default */.Z)("bg-gray-700/50 border-y border-gray-500/30", edges.leading === "capped" && "border-l rounded-tl", edges.trailing === "capped" && "border-r rounded-tr")
            }),
            edges.trailing === "normal" && /*#__PURE__*/ (0,jsx_runtime.jsx)(TabAdornment, {
                className: "inset-y-px border-r border-gray-200/5 z-20"
            }),
            isSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)(TabAdornment, {
                className: "border-b border-b-sky-300"
            })
        ]
    });
}
/**
 * Group multiple code blocks into a tabbed UI
 *
 * @param {object} props
 * @param {CodeBlock[]} props.children
 */ function SnippetGroup(param) {
    var children = param.children, actions = param.actions;
    var ref = (0,react.useState)(0), selectedIndex = ref[0], setSelectedIndex = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs_esm/* Tab.Group */.O.Group, {
        as: "div",
        onChange: setSelectedIndex,
        className: "not-prose bg-gray-800 rounded-xl shadow-md",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_esm/* Tab.List */.O.List, {
                        className: "flex text-gray-400 text-xs leading-6 overflow-hidden rounded-tl-xl pt-2",
                        children: children.map(function(child, tabIndex) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabItem, {
                                myIndex: tabIndex,
                                selectedIndex: selectedIndex,
                                children: child.props.filename
                            }, child.props.filename);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-auto flex pt-2 rounded-tr-xl overflow-hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,clsx_m/* default */.Z)("flex-auto flex justify-end bg-gray-700/50 border-y border-gray-500/30 pr-4", selectedIndex === children.length - 1 ? "rounded-tl border-l" : "")
                        })
                    }),
                    actions ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-2 right-4 h-8 flex",
                        children: actions({
                            selectedIndex: selectedIndex
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_esm/* Tab.Panels */.O.Panels, {
                className: "flex overflow-auto",
                children: children.map(function(child) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_esm/* Tab.Panel */.O.Panel, {
                        className: "flex-none min-w-full p-5 text-sm leading-6 text-gray-50 ligatures-none",
                        children: child.props.children
                    }, child.props.filename);
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/Editor.js + 1 modules
var Editor = __webpack_require__(41678);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.esm.js + 4 modules
var transition_esm = __webpack_require__(35131);
;// CONCATENATED MODULE: ./src/components/Steps.js








function Steps(param) {
    var steps = param.steps, code = param.code;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
            className: "max-w-[500px] md:max-w-[400px] lg:max-w-[600px] relative space-y-2 mb-16",
            style: {
                counterReset: "step"
            },
            children: steps.map(function(step, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    className: (0,clsx_m/* default */.Z)("relative pl-10 xl:grid grid-cols-5 gap-16 before:content-[counter(step)] before:absolute before:left-0 before:flex before:items-center before:justify-center before:w-[calc(1.375rem+1px)] before:h-[calc(1.375rem+1px)] before:text-[0.625rem] before:font-bold before:text-gray-700 before:rounded-md before:shadow-sm before:ring-1 before:ring-gray-900/5", index !== steps.length - 1 && "pb-8 after:absolute after:top-[calc(1.875rem+1px)] after:bottom-0 after:left-[0.6875rem] after:w-px after:bg-gray-200"),
                    style: {
                        counterIncrement: "step"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mb-6 col-span-2 xl:mb-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "text-sm leading-6 text-gray-900 font-semibold mb-2",
                                    children: step.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "prose prose-sm",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(step.body, {})
                                })
                            ]
                        }),
                        step.code && /*#__PURE__*/ (0,jsx_runtime.jsx)(Snippet, {
                            code: step.code,
                            highlightedCode: code[index]
                        })
                    ]
                }, step.title);
            })
        })
    });
}
function CopyButton(param) {
    var code = param.code;
    var ref = (0,react.useState)({
        state: "idle",
        i: 0
    }), ref1 = ref[0], state = ref1.state, i = ref1.i, setState = ref[1];
    (0,react.useEffect)(function() {
        if (state === "copied") {
            var handle = window.setTimeout(function() {
                setState({
                    state: "idle",
                    i: i + 1
                });
            }, 1500);
            return function() {
                window.clearTimeout(handle);
            };
        }
    }, [
        state,
        i
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative flex -mr-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: (0,clsx_m/* default */.Z)({
                    "text-gray-500 hover:text-gray-400": state === "idle",
                    "text-sky-400": state === "copied"
                }),
                onClick: function() {
                    navigator.clipboard.writeText(redent_default()(code.replace(/^[+->]/gm, " "))).then(function() {
                        setState({
                            state: "copied",
                            i: i + 1
                        });
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    "aria-hidden": "true",
                    className: "w-8 h-8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M13 10.75h-1.25a2 2 0 0 0-2 2v8.5a2 2 0 0 0 2 2h8.5a2 2 0 0 0 2-2v-8.5a2 2 0 0 0-2-2H19"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M18 12.25h-4a1 1 0 0 1-1-1v-1.5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1.5a1 1 0 0 1-1 1ZM13.75 16.25h4.5M13.75 19.25h4.5"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(transition_esm/* Transition */.u, {
                className: "absolute bottom-full left-1/2 mb-3.5 pb-1 -translate-x-1/2",
                show: state === "copied",
                enter: "transform ease-out duration-200 transition origin-bottom",
                enterFrom: "scale-95 translate-y-0.5 opacity-0",
                enterTo: "scale-100 translate-y-0 opacity-100",
                leave: "transition ease-in duration-100",
                leaveFrom: "opacity-100",
                leaveTo: "opacity-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(reach_alert_esm/* default */.Z, {
                    className: "relative bg-sky-500 text-white font-mono text-[0.625rem] leading-6 font-medium px-1.5 rounded-lg",
                    children: [
                        "Copied",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            "aria-hidden": "true",
                            width: "16",
                            height: "6",
                            viewBox: "0 0 16 6",
                            className: "text-color10 absolute top-full left-1/2 -mt-px -ml-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M15 0H1V1.00366V1.00366V1.00371H1.01672C2.72058 1.0147 4.24225 2.74704 5.42685 4.72928C6.42941 6.40691 9.57154 6.4069 10.5741 4.72926C11.7587 2.74703 13.2803 1.0147 14.9841 1.00371H15V0Z",
                                fill: "currentColor"
                            })
                        })
                    ]
                })
            })
        ]
    });
}
function Code(param) {
    var code = param.code, lang = param.lang, pad = param.pad;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {
        className: (0,clsx_m/* default */.Z)("text-sm leading-6 text-gray-50 flex ligatures-none", pad && "overflow-auto"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
            className: (0,clsx_m/* default */.Z)("flex-none min-w-full", pad && "p-5"),
            dangerouslySetInnerHTML: {
                __html: code.split("\n").map(function(line) {
                    if (lang === "terminal") {
                        line = '<span class="flex"><svg viewBox="0 -9 3 24" aria-hidden="true" class="flex-none overflow-visible text-pink-400 w-auto h-6 mr-3"><path d="M0 0L3 3L0 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span class="flex-auto">'.concat(line, "</span></span>");
                    }
                    return line;
                }).join(lang === "terminal" ? "" : "\n")
            }
        })
    });
}
function Snippet(param) {
    var code = param.code, highlightedCode = param.highlightedCode;
    if (Array.isArray(code)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "col-span-3",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SnippetGroup, {
                actions: function(param) {
                    var selectedIndex = param.selectedIndex;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyButton, {
                        code: code[selectedIndex].code
                    });
                },
                children: code.map(function(param, index) {
                    var name = param.name, lang = param.lang;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Editor/* Editor */.M, {
                        filename: name,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Code, {
                            code: highlightedCode[index],
                            lang: lang
                        })
                    }, name);
                })
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative z-10 -ml-10 col-span-3 bg-gray-800 rounded-xl shadow-lg xl:ml-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabBar, {
                name: code.name,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyButton, {
                    code: code.code
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Code, {
                    code: highlightedCode,
                    lang: code.lang,
                    pad: true
                })
            })
        ]
    });
}
function TabBar(param) {
    var name = param.name, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative flex text-gray-400 text-xs leading-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-2 flex-none text-sky-300 border-t border-b border-t-transparent border-b-sky-300 px-4 py-1 flex items-center",
                children: name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex-auto flex pt-2 rounded-tr-xl overflow-hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex-auto -mr-px bg-gray-700/50 border border-gray-500/30 rounded-tl"
                })
            }),
            children && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-2 right-0 h-8 flex items-center pr-4",
                children: children
            })
        ]
    });
}


/***/ }),

/***/ 77273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function BlockNewsletter() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "max-w-6xl mx-auto px-4 sm:px-6",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "pb-12 md:pb-20",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative bg-gray-100 rounded py-10 px-8 md:py-16 md:px-12 shadow-2xl overflow-hidden",
                    "data-aos": "zoom-y-out",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "absolute right-0 bottom-0 pointer-events-none hidden lg:block",
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                width: "428",
                                height: "328",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("radialGradient", {
                                            cx: "35.542%",
                                            cy: "34.553%",
                                            fx: "35.542%",
                                            fy: "34.553%",
                                            r: "96.031%",
                                            id: "ni-a",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                                    "stop-color": "#34CDB1",
                                                    "stop-opacity": "0.25"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                                    offset: "1",
                                                    "stop-color": "#34CDB1",
                                                    "stop-opacity": "0"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                                        fill: "none",
                                        fillRule: "evenodd",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                                                fill: "#34CDB1",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".04",
                                                        cx: "185",
                                                        cy: "15.576",
                                                        rx: "16",
                                                        ry: "15.576"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".24",
                                                        cx: "100",
                                                        cy: "68.402",
                                                        rx: "24",
                                                        ry: "23.364"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".12",
                                                        cx: "29",
                                                        cy: "251.231",
                                                        rx: "29",
                                                        ry: "28.231"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".64",
                                                        cx: "29",
                                                        cy: "251.231",
                                                        rx: "8",
                                                        ry: "7.788"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".12",
                                                        cx: "342",
                                                        cy: "31.303",
                                                        rx: "8",
                                                        ry: "7.788"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".48",
                                                        cx: "62",
                                                        cy: "126.811",
                                                        rx: "2",
                                                        ry: "1.947"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".12",
                                                        cx: "78",
                                                        cy: "7.072",
                                                        rx: "2",
                                                        ry: "1.947"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                                                        fillOpacity: ".64",
                                                        cx: "185",
                                                        cy: "15.576",
                                                        rx: "6",
                                                        ry: "5.841"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                                fill: "url(#ni-a)",
                                                cx: "276",
                                                cy: "237",
                                                r: "200"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "relative flex flex-col lg:flex-row justify-between items-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "text-center lg:text-left lg:max-w-xl",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        className: "h3 text-black mb-2",
                                        children: "More features"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-gray-700 text-lg mb-6",
                                        children: "Explore all other features in our documentation"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("form", {
                                        className: "w-full lg:w-auto",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "flex flex-col sm:flex-row justify-start max-w-xs mx-auto sm:max-w-md lg:mx-0",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                className: "btn text-white bg-blue-600 hover:bg-blue-700 shadow",
                                                href: "/docs",
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: "View Docs"
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (BlockNewsletter);


/***/ }),

/***/ 93464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BuildingBlocks_BuildingBlocks; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Widont.js
var Widont = __webpack_require__(15253);
// EXTERNAL MODULE: ./src/components/home/common.js
var common = __webpack_require__(47262);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/tabs/tabs.esm.js
var tabs_esm = __webpack_require__(66311);
// EXTERNAL MODULE: ./src/img/tradly/hero_icons/blocks.svg
var blocks = __webpack_require__(7370);
// EXTERNAL MODULE: ./src/components/home/tradlyFeatures/feature.js
var feature = __webpack_require__(6597);
// EXTERNAL MODULE: ./src/components/home/tradlyFeatures/CheckoutPage/CheckoutPageLayout.jsx + 9 modules
var CheckoutPageLayout = __webpack_require__(15024);
// EXTERNAL MODULE: ./src/components/home/tradlyFeatures/common.module.scss
var common_module = __webpack_require__(27087);
var common_module_default = /*#__PURE__*/__webpack_require__.n(common_module);
;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/CommerceFeature.js




var CommerceFeature = function() {
    var style = {};
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (common_module_default()).bg_style,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckoutPageLayout/* default */.Z, {})
    });
};
/* harmony default export */ var tradlyFeatures_CommerceFeature = (CommerceFeature);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/img/tradly/Turkish Dried Fruits.jpeg
var Turkish_Dried_Fruits = __webpack_require__(71643);
// EXTERNAL MODULE: ./src/img/tradly/Yemen coffee.jpeg
var Yemen_coffee = __webpack_require__(98634);
// EXTERNAL MODULE: ./src/img/tradly/Organic Africa's Veg.jpg
var Organic_Africa_s_Veg = __webpack_require__(82750);
// EXTERNAL MODULE: ./src/img/tradly/Nordic Flowers.jpeg
var Nordic_Flowers = __webpack_require__(50706);
;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/Marketplace/MultipleAccounts.js







var MultipleAccounts = function() {
    var data = [
        {
            id: 1,
            shop_name: "Turkish Fruits",
            account_name: "Artogul",
            image: Turkish_Dried_Fruits["default"]
        },
        {
            id: 1,
            shop_name: "Yemen Coffee ",
            account_name: "Tushar",
            image: Yemen_coffee["default"]
        },
        {
            id: 1,
            shop_name: "Dutch Vegs",
            account_name: "Akabir",
            image: Organic_Africa_s_Veg["default"]
        },
        {
            id: 1,
            shop_name: " Nordic Flowers",
            account_name: "Polash",
            image: Nordic_Flowers["default"]
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: " max-h-[490px] overflow-auto grid grid-cols-2 content-center md:p-10 md:flex md:flex-wrap justify-center items-center gap-5",
        children: data.map(function(item, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: " relative w-full md:w-[200px] transition duration-500 transform hover:scale-110 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        className: " block w-full min-h-[166px] p-2 bg-[#FEFEFE] rounded-lg shadow-md cursor-pointer",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: " rounded overflow-hidden relative mx-auto aspect-w-1 aspect-h-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: item.image,
                                    alt: "image",
                                    layout: "fill",
                                    objectFit: "cover"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-2 mb-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "w-full text-[#000000] font-semibold text-[14px] leading-4 text-left ",
                                    children: item.shop_name
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex justify-start items-center mb-2 relative",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "w-full text-[#4F4F4F] font-medium text-[14px] text-left ",
                                    children: item.account_name
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: " absolute bottom-0 right-0 mb-4 mr-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: " px-2 py-[6px] text-[10px] leading-3 items-center rounded-full border border-primary  text-primary",
                            children: "Follow"
                        })
                    })
                ]
            });
        })
    });
};
/* harmony default export */ var Marketplace_MultipleAccounts = (MultipleAccounts);

;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/MarketplaceFeature.js




var MarketplaceFeature = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (common_module_default()).bg_style,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Marketplace_MultipleAccounts, {})
    });
};
/* harmony default export */ var tradlyFeatures_MarketplaceFeature = (MarketplaceFeature);

// EXTERNAL MODULE: ./src/img/tradly/account1.png
var account1 = __webpack_require__(49609);
// EXTERNAL MODULE: ./src/img/tradly/favourite@3x.png
var favourite_3x = __webpack_require__(51574);
// EXTERNAL MODULE: ./src/img/tradly/heartIcon@3x.png
var heartIcon_3x = __webpack_require__(18356);
;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/ListingCard/ListingCard.js
/* eslint-disable react/prop-types */ 




var ListingCard = function(param) {
    var item = param.item;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: " relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: " block w-full min-h-[210px] bg-[#FEFEFE] rounded overflow-hidden cursor-pointer shadow-lg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: " aspect-w-1 aspect-h-1 relative mb-4 ",
                            children: (item === null || item === void 0 ? void 0 : (ref = item.images) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: item === null || item === void 0 ? void 0 : item.images[0],
                                alt: item.title,
                                layout: "fill",
                                objectFit: "cover"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-2 pl-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: " text-sm ms:text-base xmd:text-lg leading-[15px] font-semibold text-primary",
                                    children: item.title.length > 18 ? item.title.substring(0, 18) + ".." : item.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: " text-[14px] ms:text-[16px] mb-[14px] leading-4 font-medium text-gray-500 mt-1",
                                    children: item.list_price.formatted
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: " h-[40px] w-[40px] absolute right-0 top-0 cursor-pointer [z-100] ",
                children: item.liked ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: favourite_3x/* default */.Z,
                    alt: "follow button",
                    layout: "fill",
                    objectFit: "cover",
                    require: true
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: heartIcon_3x/* default */.Z,
                    alt: "follow button",
                    layout: "fill",
                    objectFit: "cover",
                    require: true
                })
            })
        ]
    });
};
/* harmony default export */ var ListingCard_ListingCard = (ListingCard);

// EXTERNAL MODULE: ./src/img/tradly/air-jordan-1-mid-se-shoes-hHltxp.jpeg
var air_jordan_1_mid_se_shoes_hHltxp = __webpack_require__(99996);
;// CONCATENATED MODULE: ./src/img/tradly/jordan-delta-2-shoe-dG2Stx.jpeg
/* harmony default export */ var jordan_delta_2_shoe_dG2Stx = ("/_next/static/media/jordan-delta-2-shoe-dG2Stx.0576f08b06550a19220b8c3c5b19138c.jpeg");
;// CONCATENATED MODULE: ./src/img/tradly/jordan-why-not-zer04-pf-basketball-shoe-P3c3Rp.jpeg
/* harmony default export */ var jordan_why_not_zer04_pf_basketball_shoe_P3c3Rp = ("/_next/static/media/jordan-why-not-zer04-pf-basketball-shoe-P3c3Rp.6d619bf084f503866f16c8e09bc0b570.jpeg");
;// CONCATENATED MODULE: ./src/img/tradly/zion-1-pf-basketball-shoe-bHGvxg.jpeg
/* harmony default export */ var zion_1_pf_basketball_shoe_bHGvxg = ("/_next/static/media/zion-1-pf-basketball-shoe-bHGvxg.8b51637e85db2e7d1e09f3d11efaa8d9.jpeg");
;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/ListingCard/ListingsData.js




var data = [
    {
        id: 9861,
        account_id: 3378,
        list_price: {
            amount: 186.68,
            currency: "SGD",
            formatted: "S$186.68"
        },
        category_id: [
            3430
        ],
        currency_id: 22,
        offer_percent: 0,
        stock: 5,
        shipping_charges: {
            amount: 0,
            currency: "SGD",
            formatted: "S$0"
        },
        images: [
            air_jordan_1_mid_se_shoes_hHltxp["default"]
        ],
        offer_price: {
            amount: 15,
            currency: "SGD",
            formatted: "S$15"
        },
        location: {
            city: "",
            state: "",
            country: "Singapore",
            locality: "Punggol",
            postcode: "828811",
            country_code: "sg",
            formatted_address: "Tebing Lane, Punggol, Northeast, 828811, Singapore"
        },
        type: "events",
        sold: false,
        active: true,
        status: 2,
        created_at: 1639663205,
        start_at: 1639663205,
        end_at: 1639663205,
        likes: 0,
        max_quantity: 20,
        account: {
            id: 3378,
            name: "Infiniti Kids",
            location: {
                city: "",
                state: "",
                country: "Singapore",
                locality: "Punggol",
                postcode: "828811",
                country_code: "sg",
                formatted_address: "Tebing Lane, Punggol, Northeast, 828811, Singapore"
            },
            unique_name: "",
            description: "Infiniti Kids aims to inspire children to explore and discover their potential in areas such as sports, music, art and technology so that they become confident, competent and motivated to pursue their area of interest.",
            total_followers: 0,
            total_listings: 3,
            images: [
                "https://tradly-paas.s3.amazonaws.com/images/classbubs/77393/64991909-0dcc-4478-89ed-d39b6e04dd21.JPG", 
            ],
            type: "accounts",
            active: true,
            status: 2,
            following: false,
            user: {
                email_verified: true,
                blocked: false,
                id: "e9b6c46e-3976-45b9-8f6d-a6bf580dc49d",
                first_name: "Infiniti",
                last_name: "Kids",
                profile_pic: "https://tradly-paas.s3.amazonaws.com/images/classbubs/35346/2a9043bf-b7a2-44b2-a3e5-5fa5c248046f.JPG",
                email: "info@infinitikids.org",
                mobile: "",
                dial_code: "",
                created_at: 1639277493,
                updated_at: 1639628165
            },
            category_id: []
        },
        distance: 0,
        in_cart: false,
        liked: false,
        title: "AIR JORDAN 1 MID SE",
        description: "About educator: Infiniti Kids aims to inspire children to explore and discover their potential in areas such as sports, music, art and technology so that they become confident, competent and motivated to pursue their area of interest.\n\nAbout class: Run, Jump, Throw! Infiniti Kids Multi Sports class aims to promote and develop Physical Literacy in young children, to develop them to be confident, competent and motivated in physical activity.\nOur program:\n\n Takes them through a variety of sports to allow sampling and exploration for kids to find\nwhat they truly enjoy!\n Consists of activities such as obstacle courses, circuits, fun games and sport skill\npractice, developing their fitness, fundamental movement skills and basic sports skills to\nprepare them for future sporting activities.\n Builds confidence and develop values in your child through social interactions with the\ncoaches and other children.\n\nJoin us for a fun and sweaty time!\n\nAge group: 5-7\n\nLocation: 6 Tebing Lane, S(828835)",
        coordinates: {
            latitude: 1.3929445,
            longitude: 103.9152788
        }
    },
    {
        id: 9860,
        account_id: 3378,
        list_price: {
            amount: 208.44,
            currency: "SGD",
            formatted: "S$208.44"
        },
        category_id: [
            3430
        ],
        currency_id: 22,
        offer_percent: 0,
        stock: 5,
        shipping_charges: {
            amount: 0,
            currency: "SGD",
            formatted: "S$0"
        },
        images: [
            jordan_delta_2_shoe_dG2Stx
        ],
        offer_price: {
            amount: 15,
            currency: "SGD",
            formatted: "S$15"
        },
        location: {
            city: "",
            state: "",
            country: "Singapore",
            locality: "Punggol",
            postcode: "828811",
            country_code: "sg",
            formatted_address: "Tebing Lane, Punggol, Northeast, 828811, Singapore"
        },
        type: "events",
        sold: false,
        active: true,
        status: 2,
        created_at: 1639662894,
        start_at: 1639662894,
        end_at: 1639662894,
        likes: 0,
        max_quantity: 20,
        account: {
            id: 3378,
            name: "Infiniti Kids",
            location: {
                city: "",
                state: "",
                country: "Singapore",
                locality: "Punggol",
                postcode: "828811",
                country_code: "sg",
                formatted_address: "Tebing Lane, Punggol, Northeast, 828811, Singapore"
            },
            unique_name: "",
            description: "Infiniti Kids aims to inspire children to explore and discover their potential in areas such as sports, music, art and technology so that they become confident, competent and motivated to pursue their area of interest.",
            total_followers: 0,
            total_listings: 3,
            images: [
                jordan_delta_2_shoe_dG2Stx
            ],
            type: "accounts",
            active: true,
            status: 2,
            following: false,
            user: {
                email_verified: true,
                blocked: false,
                id: "e9b6c46e-3976-45b9-8f6d-a6bf580dc49d",
                first_name: "Infiniti",
                last_name: "Kids",
                profile_pic: "https://tradly-paas.s3.amazonaws.com/images/classbubs/35346/2a9043bf-b7a2-44b2-a3e5-5fa5c248046f.JPG",
                email: "info@infinitikids.org",
                mobile: "",
                dial_code: "",
                created_at: 1639277493,
                updated_at: 1639628165
            },
            category_id: []
        },
        distance: 0,
        in_cart: false,
        liked: true,
        title: "JORDAN DELTA 2",
        description: "About educator: Infiniti Kids aims to inspire children to explore and discover their potential in areas such as sports, music, art and technology so that they become confident, competent and motivated to pursue their area of interest.\n\nAbout class: Run, Jump, Throw! Infiniti Kids Multi Sports class aims to promote and develop Physical Literacy in young children, to develop them to be confident, competent and motivated in physical activity.\nOur program:\n\n Takes them through a variety of sports to allow sampling and exploration for kids to find\nwhat they truly enjoy!\n Consists of activities such as obstacle courses, circuits, fun games and sport skill\npractice, developing their fitness, fundamental movement skills and basic sports skills to\nprepare them for future sporting activities.\n Builds confidence and develop values in your child through social interactions with the\ncoaches and other children.\n\nJoin us for a fun and sweaty time!\n\nAge group: 3-5\n\nLocation: 6 Tebing Lane, S(828835)",
        coordinates: {
            latitude: 1.3929445,
            longitude: 103.9152788
        }
    },
    {
        id: 9859,
        account_id: 3378,
        list_price: {
            amount: 208.44,
            currency: "SGD",
            formatted: "S$208.44"
        },
        category_id: [
            3430
        ],
        currency_id: 22,
        offer_percent: 0,
        stock: 5,
        shipping_charges: {
            amount: 0,
            currency: "SGD",
            formatted: "S$0"
        },
        images: [
            jordan_why_not_zer04_pf_basketball_shoe_P3c3Rp
        ],
        offer_price: {
            amount: 190,
            currency: "SGD",
            formatted: "S$208.44"
        },
        location: {
            city: "Singapore",
            state: "",
            country: "Singapore",
            locality: "Geylang",
            postcode: "409961",
            country_code: "sg",
            formatted_address: "LTC Industrial Building D, 16, Arumugam Road, Geylang, Singapore, Southeast, 409961, Singapore"
        },
        type: "events",
        sold: false,
        active: true,
        status: 2,
        created_at: 1639662715,
        start_at: 1639662715,
        end_at: 1639662715,
        likes: 0,
        max_quantity: 20,
        account: {
            id: 3378,
            name: "Infiniti Kids",
            location: {
                city: "",
                state: "",
                country: "Singapore",
                locality: "Punggol",
                postcode: "828811",
                country_code: "sg",
                formatted_address: "Tebing Lane, Punggol, Northeast, 828811, Singapore"
            },
            unique_name: "",
            description: "Infiniti Kids aims to inspire children to explore and discover their potential in areas such as sports, music, art and technology so that they become confident, competent and motivated to pursue their area of interest.",
            total_followers: 0,
            total_listings: 3,
            images: [
                "https://tradly-paas.s3.amazonaws.com/images/classbubs/77393/64991909-0dcc-4478-89ed-d39b6e04dd21.JPG", 
            ],
            type: "accounts",
            active: true,
            status: 2,
            following: false,
            user: {
                email_verified: true,
                blocked: false,
                id: "e9b6c46e-3976-45b9-8f6d-a6bf580dc49d",
                first_name: "Infiniti",
                last_name: "Kids",
                profile_pic: "https://tradly-paas.s3.amazonaws.com/images/classbubs/35346/2a9043bf-b7a2-44b2-a3e5-5fa5c248046f.JPG",
                email: "info@infinitikids.org",
                mobile: "",
                dial_code: "",
                created_at: 1639277493,
                updated_at: 1639628165
            },
            category_id: []
        },
        distance: 0,
        in_cart: false,
        liked: true,
        title: "JORDAN 'WHY NOT?' ZER0.4 PF",
        description: "About educator: Infiniti Kids aims to inspire children to explore and discover their potential in areas such as sports, music, art and technology so that they become confident, competent and motivated to pursue their area of interest.\n\nAbout class: Run, Jump, Throw! Infiniti Kids Multi Sports class aims to promote and develop Physical Literacy in young children, to develop them to be confident, competent and motivated in physical activity.\nOur program:\n\n Takes them through a variety of sports to allow sampling and exploration for kids to find\nwhat they truly enjoy!\n Consists of activities such as obstacle courses, circuits, fun games and sport skill\npractice, developing their fitness, fundamental movement skills and basic sports skills to\nprepare them for future sporting activities.\n Builds confidence and develop values in your child through social interactions with the\ncoaches and other children.\n\nJoin us for a fun and sweaty time!\n\nAge group: 3-5\n\nLocation: 16 Arumugam Rd, Singapore 409961",
        coordinates: {
            latitude: 1.3253893,
            longitude: 103.8915179
        }
    },
    {
        id: 9858,
        account_id: 3380,
        list_price: {
            amount: 186.68,
            currency: "SGD",
            formatted: "S$186.68"
        },
        category_id: [
            3421
        ],
        currency_id: 22,
        offer_percent: 0,
        stock: 5,
        shipping_charges: {
            amount: 0,
            currency: "SGD",
            formatted: "S$0"
        },
        images: [
            zion_1_pf_basketball_shoe_bHGvxg
        ],
        offer_price: {
            amount: 65,
            currency: "SGD",
            formatted: "S$65"
        },
        location: {
            city: "Singapore",
            state: "",
            country: "Singapore",
            locality: "Queenstown",
            postcode: "138694",
            country_code: "sg",
            formatted_address: "Centre Stage Scool of the Arts, 15, Woking Road, Nepal Hill, Queenstown, Singapore, Central, 138694, Singapore"
        },
        type: "events",
        sold: false,
        active: true,
        status: 2,
        created_at: 1639662164,
        start_at: 1639662163,
        end_at: 1639662163,
        likes: 0,
        max_quantity: 20,
        account: {
            id: 3380,
            name: "Centre Stage School of the Arts",
            location: {
                city: "Singapore",
                state: "",
                country: "Singapore",
                locality: "Queenstown",
                postcode: "138694",
                country_code: "sg",
                formatted_address: "Centre Stage Scool of the Arts, 15, Woking Road, Nepal Hill, Queenstown, Singapore, Central, 138694, Singapore"
            },
            unique_name: "",
            description: "We have been providing workshops for all ages in Singapore since 1999, with a team of specialized, performers, educators, and teachers, passionate about the Arts, Creativity, Communication & Performance. We deliver Theatre in Education Drama, Movement, Dance, Singing, Performance Workshops for Children & Adults. As well as Teacher Training Workshops, Corporate Training, Creative Arts Workshops, Interactive Storytelling with follow up workshops.",
            total_followers: 0,
            total_listings: 6,
            images: [
                "https://tradly-paas.s3.amazonaws.com/images/classbubs/28970/b8b258a2-6034-4e24-8f6f-526eecc32f94.PNG", 
            ],
            type: "accounts",
            active: true,
            status: 2,
            following: false,
            user: {
                email_verified: true,
                blocked: false,
                id: "9a6662be-2010-4b96-bb5c-4a5fefc17aef",
                first_name: "Centre Stage",
                last_name: "School Of The Arts",
                profile_pic: "https://tradly-paas.s3.amazonaws.com/images/classbubs/62791/2987fcf7-67c7-4517-bc6a-27b6ba02c685.PNG",
                email: "nadine@centre-stage.com",
                mobile: "",
                dial_code: "",
                created_at: 1639448154,
                updated_at: 1639628396
            },
            category_id: []
        },
        distance: 0,
        in_cart: false,
        liked: false,
        title: "Zion 1 PF",
        description: "About educator: We have been providing workshops for all ages in Singapore since 1999, with a team of specialized, performers, educators, and teachers, passionate about the Arts, Creativity, Communication & Performance. We deliver Theatre in Education Drama, Movement, Dance, Singing, Performance Workshops for Children & Adults. As well as Teacher Training Workshops, Corporate Training, Creative Arts Workshops, Interactive Storytelling with follow up workshops.\n\nAbout class: Please note that class level assignment will be at the sole discretion of the Ballet Mistress.\n\nThe Graded Examination Syllabus consists of three different components: classical, free movement and character dance.\n\nClassical: the foundation and most important part of the Graded Syllabi.\nFree movement: incorporates movements in common with other dance styles such as natural movement, contemporary based dance and Greek dance.\nCharacter dance: is the theatrical presentation of national dance using original ethnic dance and music that has been freely adapted for the theatre. There are three styles – Hungarian, Russian and Polish – and these were selected because of their historic importance in the development of the traditional full-length classical ballets.\n\nAge group: 7+\n\nLocation: 15 Woking Rd",
        coordinates: {
            latitude: 1.29651935,
            longitude: 103.7941889775051
        }
    }, 
];

;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/MultipleListings.js




var MultipleListings = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-white md:p-8 rounded-lg shadow-lg ",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "grid grid-cols-2 gap-5 justify-center",
            children: data === null || data === void 0 ? void 0 : data.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: " relative",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListingCard_ListingCard, {
                        item: item
                    })
                }, Math.random());
            })
        })
    });
};
/* harmony default export */ var tradlyFeatures_MultipleListings = (MultipleListings);

;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/SocialFeature/AccountDetails.js







var AccountDetails = function() {
    var ref = (0,react.useState)(false), follow = ref[0], setFollow = ref[1];
    var data = [
        // {
        //   title: 'Description',
        //   value: account_details?.description,
        //   extra_style: true,
        // },
        {
            title: "Categories",
            value: "Table & Chair",
            extra_style: false
        },
        {
            title: "Location",
            value: "Malashiya" || 0,
            extra_style: false
        },
        {
            title: "Total Followers",
            value: 100
        },
        {
            title: "Total Listings",
            value: 50,
            extra_style: false
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "max-w-[600px] mx-auto",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-full relative ",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: " relative w-full min-h-[126px] px-[10px] sm:px-[40px] py-[20px] bg-white rounded-[10px] shadow-lg ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: " flex items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: " w-[60px] h-[60px] rounded-full overflow-hidden relative mr-6 ",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: account1["default"],
                                        layout: "fill",
                                        objectFit: "cover",
                                        alt: "banner"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: " flex flex-col items-start",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: " font-semibold text-base text-black",
                                            children: " Jay Z shop"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: " text-secondary text-sm",
                                            children: "@jay"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: " grid grid-cols-3 items-center justify-between divide-x",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: " h-[50px] flex justify-center ",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "flex items-center gap-1",
                                        children: [
                                            "0.0",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                class: "h-5 w-5",
                                                viewBox: "0 0 20 20",
                                                fill: "#ff9529",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: " flex flex-col items-center text-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "font-semibold text-base text-gray-900 text-center",
                                            children: " 30"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Total Products"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: " flex flex-col items-center border-l-2 border-gray-400 border-opacity-70 ",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: " font-semibold text-base text-gray-900 ",
                                            children: "100"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Followers"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: " mt-5 grid grid-cols-3 ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: [
                                        "px-2  md:w-[145px] h-[35px] flex justify-center items-center border border-primary  rounded-lg mx-auto",
                                        follow ? "text-[#FFFFFF]  bg-primary" : "text-primary   bg-transparent", 
                                    ].join(" "),
                                    onClick: function() {
                                        return setFollow(!follow);
                                    },
                                    children: follow ? "Following" : "Follow"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    className: "px-2  md:w-[145px] h-[35px] flex justify-center items-center border border-primary  rounded-lg text-primary   mx-auto",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            class: "h-6 w-6",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            stroke: "currentColor",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                                "stroke-width": "2",
                                                d: "M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"
                                            })
                                        }),
                                        "Share"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    className: [
                                        " px-2  md:w-[145px] h-[35px] flex justify-center items-center border border-primary  rounded-lg   text-primary mx-auto", 
                                    ].join(" "),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            class: "h-6 w-6",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            stroke: "currentColor",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                                "stroke-width": "2",
                                                d: "M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                                            })
                                        }),
                                        "Chat"
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: " mt-5 rounded-xl shadow-c-xsm ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tradlyFeatures_MultipleListings, {})
                })
            ]
        })
    });
};
/* harmony default export */ var SocialFeature_AccountDetails = (AccountDetails);

;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/SocialFeature/SocialFeature.js






var SocialFeature = function() {
    var showFollow = false;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (common_module_default()).bg_style,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: " md:p-10 max-h-[450px] overflow-auto ",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialFeature_AccountDetails, {})
        })
    });
};
/* harmony default export */ var SocialFeature_SocialFeature = (SocialFeature);

// EXTERNAL MODULE: ./src/components/Tradly/BlockNewsletter.js
var BlockNewsletter = __webpack_require__(77273);
;// CONCATENATED MODULE: ./src/components/home/tradly-home/BuildingBlocks/BuildingBlocks.jsx












function classNames() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(" ");
}
var BuildingBlocks = function() {
    var ref = (0,react.useState)([
        {
            id: 1,
            buttonTitle: "Commerce",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19 7H16V6C16 4.93913 15.5786 3.92172 14.8284 3.17157C14.0783 2.42143 13.0609 2 12 2C10.9391 2 9.92172 2.42143 9.17157 3.17157C8.42143 3.92172 8 4.93913 8 6V7H5C4.73478 7 4.48043 7.10536 4.29289 7.29289C4.10536 7.48043 4 7.73478 4 8V19C4 19.7956 4.31607 20.5587 4.87868 21.1213C5.44129 21.6839 6.20435 22 7 22H17C17.7956 22 18.5587 21.6839 19.1213 21.1213C19.6839 20.5587 20 19.7956 20 19V8C20 7.73478 19.8946 7.48043 19.7071 7.29289C19.5196 7.10536 19.2652 7 19 7ZM10 6C10 5.46957 10.2107 4.96086 10.5858 4.58579C10.9609 4.21071 11.4696 4 12 4C12.5304 4 13.0391 4.21071 13.4142 4.58579C13.7893 4.96086 14 5.46957 14 6V7H10V6ZM18 19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H7C6.73478 20 6.48043 19.8946 6.29289 19.7071C6.10536 19.5196 6 19.2652 6 19V9H8V10C8 10.2652 8.10536 10.5196 8.29289 10.7071C8.48043 10.8946 8.73478 11 9 11C9.26522 11 9.51957 10.8946 9.70711 10.7071C9.89464 10.5196 10 10.2652 10 10V9H14V10C14 10.2652 14.1054 10.5196 14.2929 10.7071C14.4804 10.8946 14.7348 11 15 11C15.2652 11 15.5196 10.8946 15.7071 10.7071C15.8946 10.5196 16 10.2652 16 10V9H18V19Z"
            }),
            feature: tradlyFeatures_CommerceFeature
        },
        {
            id: 2,
            buttonTitle: "Marketplace",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1 12.5V17.5C1 17.7652 1.10536 18.0196 1.29289 18.2071C1.48043 18.3946 1.73478 18.5 2 18.5H3C3 19.2956 3.31607 20.0587 3.87868 20.6213C4.44129 21.1839 5.20435 21.5 6 21.5C6.79565 21.5 7.55871 21.1839 8.12132 20.6213C8.68393 20.0587 9 19.2956 9 18.5H15C15 19.2956 15.3161 20.0587 15.8787 20.6213C16.4413 21.1839 17.2044 21.5 18 21.5C18.7956 21.5 19.5587 21.1839 20.1213 20.6213C20.6839 20.0587 21 19.2956 21 18.5H22C22.2652 18.5 22.5196 18.3946 22.7071 18.2071C22.8946 18.0196 23 17.7652 23 17.5V5.5C23 4.70435 22.6839 3.94129 22.1213 3.37868C21.5587 2.81607 20.7956 2.5 20 2.5H11C10.2044 2.5 9.44129 2.81607 8.87868 3.37868C8.31607 3.94129 8 4.70435 8 5.5V7.5H6C5.53426 7.5 5.07493 7.60844 4.65836 7.81672C4.24179 8.025 3.87944 8.32741 3.6 8.7L1.2 11.9C1.17075 11.9435 1.14722 11.9905 1.13 12.04L1.07 12.15C1.02587 12.2615 1.00216 12.3801 1 12.5ZM17 18.5C17 18.3022 17.0586 18.1089 17.1685 17.9444C17.2784 17.78 17.4346 17.6518 17.6173 17.5761C17.8 17.5004 18.0011 17.4806 18.1951 17.5192C18.3891 17.5578 18.5673 17.653 18.7071 17.7929C18.847 17.9327 18.9422 18.1109 18.9808 18.3049C19.0194 18.4989 18.9996 18.7 18.9239 18.8827C18.8482 19.0654 18.72 19.2216 18.5556 19.3315C18.3911 19.4414 18.1978 19.5 18 19.5C17.7348 19.5 17.4804 19.3946 17.2929 19.2071C17.1054 19.0196 17 18.7652 17 18.5ZM10 5.5C10 5.23478 10.1054 4.98043 10.2929 4.79289C10.4804 4.60536 10.7348 4.5 11 4.5H20C20.2652 4.5 20.5196 4.60536 20.7071 4.79289C20.8946 4.98043 21 5.23478 21 5.5V16.5H20.22C19.9388 16.1906 19.5961 15.9435 19.2138 15.7743C18.8315 15.6052 18.418 15.5178 18 15.5178C17.582 15.5178 17.1685 15.6052 16.7862 15.7743C16.4039 15.9435 16.0612 16.1906 15.78 16.5H10V5.5ZM8 11.5H4L5.2 9.9C5.29315 9.7758 5.41393 9.675 5.55279 9.60557C5.69164 9.53615 5.84475 9.5 6 9.5H8V11.5ZM5 18.5C5 18.3022 5.05865 18.1089 5.16853 17.9444C5.27841 17.78 5.43459 17.6518 5.61732 17.5761C5.80004 17.5004 6.00111 17.4806 6.19509 17.5192C6.38907 17.5578 6.56725 17.653 6.70711 17.7929C6.84696 17.9327 6.9422 18.1109 6.98079 18.3049C7.01937 18.4989 6.99957 18.7 6.92388 18.8827C6.84819 19.0654 6.72002 19.2216 6.55557 19.3315C6.39112 19.4414 6.19778 19.5 6 19.5C5.73478 19.5 5.48043 19.3946 5.29289 19.2071C5.10536 19.0196 5 18.7652 5 18.5ZM3 13.5H8V16.28C7.40983 15.7526 6.63513 15.4797 5.84469 15.5209C5.05425 15.5621 4.31212 15.914 3.78 16.5H3V13.5Z"
            }),
            feature: tradlyFeatures_MarketplaceFeature
        },
        {
            id: 3,
            buttonTitle: "Social ",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.9999 8.35C11.4285 8.05705 10.7796 7.95062 10.1446 8.04569C9.50961 8.14077 8.92039 8.43256 8.45987 8.88C7.89806 9.4425 7.58251 10.205 7.58251 11C7.58251 11.795 7.89806 12.5575 8.45987 13.12L11.2899 16C11.3828 16.0937 11.4934 16.1681 11.6153 16.2189C11.7371 16.2697 11.8679 16.2958 11.9999 16.2958C12.1319 16.2958 12.2626 16.2697 12.3844 16.2189C12.5063 16.1681 12.6169 16.0937 12.7099 16L15.5399 13.17C16.1017 12.6075 16.4172 11.845 16.4172 11.05C16.4172 10.255 16.1017 9.4925 15.5399 8.93C15.0851 8.47439 14.4986 8.17326 13.8634 8.06918C13.2281 7.9651 12.5762 8.06333 11.9999 8.35ZM14.1199 11.71L11.9999 13.83L9.87987 11.71C9.78614 11.617 9.71174 11.5064 9.66097 11.3846C9.61021 11.2627 9.58407 11.132 9.58407 11C9.58407 10.868 9.61021 10.7373 9.66097 10.6154C9.71174 10.4936 9.78614 10.383 9.87987 10.29C10.0672 10.1037 10.3207 9.99921 10.5849 9.99921C10.8491 9.99921 11.1025 10.1037 11.2899 10.29C11.3828 10.3837 11.4934 10.4581 11.6153 10.5089C11.7371 10.5597 11.8679 10.5858 11.9999 10.5858C12.1319 10.5858 12.2626 10.5597 12.3844 10.5089C12.5063 10.4581 12.6169 10.3837 12.7099 10.29C12.8972 10.1037 13.1507 9.99921 13.4149 9.99921C13.6791 9.99921 13.9325 10.1037 14.1199 10.29C14.2136 10.383 14.288 10.4936 14.3388 10.6154C14.3895 10.7373 14.4157 10.868 14.4157 11C14.4157 11.132 14.3895 11.2627 14.3388 11.3846C14.288 11.5064 14.2136 11.617 14.1199 11.71ZM11.9999 2C10.6866 2 9.38629 2.25866 8.17303 2.7612C6.95978 3.26375 5.85738 4.00035 4.9288 4.92893C3.05343 6.8043 1.99987 9.34784 1.99987 12C1.99112 14.3091 2.79066 16.5485 4.25987 18.33L2.25987 20.33C2.12111 20.4706 2.02711 20.6492 1.98974 20.8432C1.95236 21.0372 1.97329 21.2379 2.04987 21.42C2.13292 21.5999 2.26757 21.7511 2.43671 21.8544C2.60586 21.9577 2.80187 22.0083 2.99987 22H11.9999C14.652 22 17.1956 20.9464 19.0709 19.0711C20.9463 17.1957 21.9999 14.6522 21.9999 12C21.9999 9.34784 20.9463 6.8043 19.0709 4.92893C17.1956 3.05357 14.652 2 11.9999 2ZM11.9999 20H5.40987L6.33987 19.07C6.52612 18.8826 6.63066 18.6292 6.63066 18.365C6.63066 18.1008 6.52612 17.8474 6.33987 17.66C5.03045 16.352 4.21504 14.6305 4.03256 12.7888C3.85007 10.947 4.31181 9.09901 5.33909 7.55952C6.36638 6.02004 7.89566 4.88436 9.66638 4.34597C11.4371 3.80759 13.3397 3.8998 15.0501 4.60691C16.7604 5.31402 18.1727 6.59227 19.0463 8.22389C19.9199 9.85551 20.2007 11.7395 19.841 13.555C19.4813 15.3705 18.5032 17.005 17.0734 18.1802C15.6436 19.3554 13.8506 19.9985 11.9999 20Z"
            }),
            feature: SocialFeature_SocialFeature
        }, 
    ]), categories = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "max-w-7xl mx-auto px-4 sm:px-6 md:px-8 pt-20",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: blocks/* default */.Z,
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Caption */.YS, {
                className: "text-color3",
                children: "Building Blocks"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* BigText */.y8, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Widont/* Widont */.X, {
                    children: "Carefully chosen building blocks"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Paragraph */.nv, {
                children: "Tradly solutions geared toward platform economy business models plus commerce solutions. Find blocks to build unique apps that has Social, Booking, Wallet, Videos, Reviews, Chat, Onboarding and many more."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full py-16 sm:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs_esm/* Tab.Group */.O.Group, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_esm/* Tab.List */.O.List, {
                            className: "flex p-1 items-center gap-7 ",
                            children: categories.map(function(category) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs_esm/* Tab */.O, {
                                    className: function(param) {
                                        var selected = param.selected;
                                        return classNames("w-[96px] py-2.5 text-sm leading-5 font-medium rounded-lg flex flex-col justify-center items-center gap-6  group outline-none ", selected ? "  transition duration-500 text-color3" : "text-gray-300  hover:text-gray-400");
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            class: "h-12 w-12",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            stroke: "currentColor",
                                            children: category.icon
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "",
                                            children: category.buttonTitle
                                        })
                                    ]
                                }, category);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_esm/* Tab.Panels */.O.Panels, {
                            className: "mt-10 max-h-[500px] md:max-h-full ",
                            children: categories.map(function(post, idx) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(tabs_esm/* Tab.Panel */.O.Panel, {
                                    className: classNames("bg-white rounded-xl   md:p-3"),
                                    children: post === null || post === void 0 ? void 0 : post.feature
                                }, idx);
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var BuildingBlocks_BuildingBlocks = (BuildingBlocks);


/***/ }),

/***/ 24062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ tradly_home_DeveloperExperience; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Widont.js
var Widont = __webpack_require__(15253);
// EXTERNAL MODULE: ./src/components/home/common.js
var common = __webpack_require__(47262);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/tabs/tabs.esm.js
var tabs_esm = __webpack_require__(66311);
;// CONCATENATED MODULE: ./src/img/tradly/hero_icons/developers.svg
var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function SvgDevelopers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "20 10 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#developers_svg__filter0_d_1220_139)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 10,
    width: 50,
    height: 50,
    rx: 20,
    fill: "#154A80"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.262 22H36.155A5.155 5.155 0 0031 27.155v11.22a5.155 5.155 0 005.155 5.155h2.455c.117 0 .211.094.211.211v5.535c0 .654.8.972 1.25.495l5.806-6.175a.211.211 0 01.154-.066h7.231a5.155 5.155 0 005.155-5.155v-11.22A5.155 5.155 0 0053.262 22z",
    fill: "#EC5569"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.99 41.606c0-.123-.092-.222-.205-.222h-2.377c-2.756 0-4.99-2.43-4.99-5.429V24.14c0-.508.064-.998.184-1.464A5.153 5.153 0 0031 27.155v11.22a5.155 5.155 0 005.155 5.155h2.455c.117 0 .211.095.211.212v5.534c0 .655.8.972 1.25.495l.919-.978v-7.187z",
    fill: "#E63950"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 28.69a3.351 3.351 0 00-4.74 0l-.739.739a.451.451 0 01-.638 0l-.727-.728a3.351 3.351 0 10-4.74 4.74l5.467 5.467a.452.452 0 00.639 0L50.5 33.43a3.351 3.351 0 000-4.74z",
    fill: "#EC5569"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 28.69a3.351 3.351 0 00-4.74 0l-.739.739a.451.451 0 01-.638 0l-.727-.728a3.351 3.351 0 10-4.74 4.74l5.467 5.467a.452.452 0 00.639 0L50.5 33.43a3.351 3.351 0 000-4.74z",
    fill: "#FFF5F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.67 33.44a3.351 3.351 0 011.492-5.603 3.351 3.351 0 00-3.246 5.604l5.467 5.467a.451.451 0 00.639 0l.557-.557-4.91-4.91z",
    fill: "#DCE6EB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "developers_svg__filter0_d_1220_139",
    x: 0,
    y: 0,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.160784 0 0 0 0 0.160784 0 0 0 0 0.164706 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1220_139"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1220_139",
    result: "shape"
  })))));
}
/* harmony default export */ var developers = ("/_next/static/media/developers.c516f76151b552e5ac5a7a58f305d153.svg");

// EXTERNAL MODULE: ./src/components/home/tradlyFeatures/feature.js
var feature = __webpack_require__(6597);
// EXTERNAL MODULE: ./src/components/Steps.js + 1 modules
var Steps = __webpack_require__(49289);
;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/JsSdkFeature.js


function JsSdkFeature() {
    var steps = [
        {
            title: "Install TradlyJS SDK ",
            body: function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        "Install ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                            children: "JS SDK"
                        }),
                        " via npm."
                    ]
                });
            },
            code: {
                name: "Terminal",
                lang: "terminal",
                code: "npm install  tradly"
            }
        },
        {
            title: "Initialization of SDK",
            body: function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        "Add your tradly token and environment name in your ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                            children: "app.js"
                        }),
                        " file."
                    ]
                });
            },
            code: {
                name: "app.js",
                lang: "js",
                code: "import TradlySDK from 'tradly'; \nTradlySDK.init.config({token:'',environment:'production'})"
            }
        },
        {
            title: "Example",
            body: function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: " Start with tradly JS SDK and enjoy \uD83C\uDF89"
                });
            },
            code: {
                name: "app.js",
                lang: "js",
                code: "const [error, responseJson]  = await TradlySDK.app.getCategory({bodyParam:{'type':'listings'},authKey:'authkey'})\n        "
            }
        }, 
    ];
    var code = steps.map(function(param) {
        var code = param.code;
        var isArray = Array.isArray(code);
        code = isArray ? code : [
            code
        ];
        code = code.map(function(code) {
            return code.code;
        });
        return isArray ? code : code[0];
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative h-[500px] overflow-auto",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Steps/* Steps */.R, {
            steps: steps,
            code: code
        })
    });
}

;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/ApiReferenceFeature.js


function ApiReferenceFeature() {
    var steps = [
        {
            title: "Base URLs",
            body: function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "You can access Tradly API via one of the below endpoints."
                });
            },
            code: {
                name: "api.js",
                lang: "js",
                code: "Production: https://api.tradly.app"
            }
        },
        {
            title: "Authentication",
            body: function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "In order to access APIs, you will need a valid API KEY. This key is generated when your sign up is complete and you can always access this via the Superadmin Panel Get your API keys from https://tradly.app/signup"
                });
            },
            code: {
                name: "\uD83C\uDF10https://developer.tradly.app/",
                lang: "web",
                code: "Once signed up, go to Settings > API\n\nTradly offers two different keys: publishable key and secret key\n\nsecret key: access to all API endpoints including admin related endpoints. Endpoints that can be accessed only by secret key are marked as [ADMIN].\npublishable key: access to all endpoints other than admin endpoints.\nAll requests need API KEY in the request header as Bearer token as shown below,\n\nAuthorization: Bearer pk_test_60cc337410424b0abfbc0332e49c\n\n"
            }
        },
        {
            title: "Example",
            body: function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: " Start with tradly api reference and enjoy \uD83C\uDF89"
                });
            },
            code: {
                name: "api.js",
                lang: "js",
                code: "var axios = require('axios');\nvar data = '';\n\nvar config = {\n  method: 'get',\n  url: 'https://api.tradly.app/v1/categories?parent={{parent_id}}&type={{type}}',\n  headers: { \n    'Content-Type': 'application/json'\n  },\n  data : data\n};\n\naxios(config)\n.then(function (response) {\n  console.log(JSON.stringify(response.data));\n})\n.catch(function (error) {\n  console.log(error);\n});"
            }
        }, 
    ];
    var code = steps.map(function(param) {
        var code = param.code;
        var isArray = Array.isArray(code);
        code = isArray ? code : [
            code
        ];
        code = code.map(function(code) {
            return code.code;
        });
        return isArray ? code : code[0];
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative h-[500px] overflow-auto",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Steps/* Steps */.R, {
            steps: steps,
            code: code
        })
    });
}

;// CONCATENATED MODULE: ./src/components/home/tradly-home/DeveloperExperience.jsx










function classNames() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(" ");
}
var DeveloperExperience = function() {
    var ref = (0,react.useState)([
        {
            id: 1,
            buttonTitle: "Js SDK",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.4778 14.8829C13.7259 14.9562 12.9684 14.8183 12.2906 14.4847C12.137 14.3618 12.0103 14.2088 11.9182 14.035C11.8261 13.8613 11.7706 13.6705 11.7551 13.4745C11.7548 13.4451 11.7487 13.4162 11.7371 13.3892C11.7255 13.3622 11.7087 13.3379 11.6876 13.3175C11.6665 13.2971 11.6416 13.281 11.6143 13.2703C11.587 13.2596 11.5578 13.2544 11.5285 13.255C11.2119 13.2512 10.8954 13.252 10.5788 13.2546C10.5235 13.249 10.4682 13.2654 10.4249 13.3002C10.3816 13.3351 10.3537 13.3856 10.3474 13.4409C10.3294 13.7848 10.3875 14.1285 10.5177 14.4474C10.6479 14.7662 10.8469 15.0524 11.1005 15.2854C11.7407 15.785 12.518 16.0774 13.3288 16.1236C14.1735 16.2216 15.0284 16.1853 15.8618 16.0161C16.5018 15.8967 17.0885 15.5805 17.5401 15.1117C17.7897 14.8039 17.957 14.4377 18.0263 14.0474C18.0956 13.6572 18.0645 13.2558 17.9361 12.8809C17.8282 12.6166 17.6612 12.3805 17.4479 12.1908C17.2346 12.0011 16.9807 11.8627 16.7057 11.7864C15.4249 11.337 14.0414 11.3709 12.7357 11.0295C12.509 10.9581 12.232 10.8807 12.131 10.6407C12.0726 10.4718 12.0686 10.2889 12.1196 10.1176C12.1706 9.94632 12.2739 9.79535 12.4152 9.68589C12.8251 9.45159 13.292 9.33536 13.7639 9.35008C14.4045 9.28978 15.0502 9.38217 15.6481 9.61967C15.8277 9.7253 15.9822 9.86876 16.1008 10.0401C16.2194 10.2114 16.2993 10.4065 16.3349 10.6119C16.3366 10.6724 16.3609 10.7302 16.403 10.7738C16.4451 10.8174 16.502 10.8437 16.5625 10.8475C16.8768 10.8539 17.1912 10.8492 17.5056 10.8496C17.5601 10.8562 17.6151 10.8428 17.6606 10.812C17.706 10.7812 17.7388 10.735 17.7529 10.6819C17.7557 10.2579 17.6477 9.84057 17.4395 9.47118C17.2314 9.10178 16.9304 8.79318 16.5662 8.57593C15.5613 8.11211 14.4457 7.94142 13.348 8.0835V8.08342C12.5438 8.11639 11.7754 8.42513 11.1719 8.9578C10.8948 9.25641 10.7072 9.62683 10.6304 10.0269C10.5536 10.4269 10.5907 10.8405 10.7375 11.2204C10.8518 11.475 11.0199 11.7017 11.2302 11.885C11.4405 12.0683 11.6881 12.2038 11.9559 12.2822C13.2324 12.7433 14.6314 12.5953 15.9203 13.003C16.1715 13.0882 16.464 13.2185 16.5409 13.4981C16.5823 13.6656 16.5791 13.8411 16.5318 14.007C16.4845 14.173 16.3947 14.3237 16.2713 14.4442C15.7352 14.7772 15.107 14.9309 14.4778 14.8829ZM20.2967 6.43754C17.8045 5.0282 15.3117 3.62014 12.8183 2.21336C12.5681 2.07347 12.2862 2.00002 11.9996 2.00002C11.713 2.00002 11.4311 2.07347 11.1809 2.21336C8.69726 3.61589 6.21344 5.01836 3.72949 6.42076C3.48785 6.55247 3.28584 6.74643 3.14444 6.98253C3.00303 7.21863 2.92736 7.48827 2.92529 7.76347V16.2377C2.92927 16.5179 3.00901 16.7918 3.15605 17.0304C3.30309 17.2689 3.51196 17.4632 3.76049 17.5927C4.474 17.9811 5.16723 18.409 5.89367 18.7715C6.31296 18.9957 6.77865 19.1192 7.2539 19.1322C7.72916 19.1453 8.20093 19.0476 8.63189 18.8468C8.95436 18.6448 9.21676 18.36 9.39173 18.0221C9.5667 17.6842 9.64785 17.3056 9.62671 16.9257C9.63226 14.129 9.62756 11.3321 9.62884 8.5354C9.63371 8.50482 9.63206 8.47356 9.62401 8.44366C9.61596 8.41377 9.60168 8.38591 9.58211 8.36192C9.56254 8.33792 9.53813 8.31833 9.51046 8.30443C9.48279 8.29053 9.4525 8.28263 9.42157 8.28125C9.10418 8.27612 8.78631 8.27825 8.46893 8.2804C8.43955 8.27776 8.40993 8.28136 8.38204 8.29097C8.35414 8.30058 8.32859 8.31598 8.30706 8.33616C8.28553 8.35633 8.26851 8.38083 8.25712 8.40805C8.24572 8.43526 8.2402 8.46458 8.24093 8.49408C8.23666 11.2728 8.24179 14.0524 8.23837 16.8315C8.2391 17.0234 8.18115 17.2108 8.0723 17.3688C7.96345 17.5268 7.80889 17.6476 7.62937 17.7153C7.42265 17.7764 7.20536 17.7932 6.9917 17.7646C6.77804 17.736 6.57282 17.6626 6.38944 17.5493C5.72843 17.176 5.06743 16.8027 4.40644 16.4294C4.36265 16.4087 4.32626 16.375 4.30219 16.3329C4.27811 16.2909 4.26751 16.2424 4.2718 16.1941C4.2718 13.3983 4.2718 10.6025 4.2718 7.80689C4.26721 7.7525 4.27991 7.69806 4.30811 7.65133C4.33631 7.6046 4.37855 7.56797 4.4288 7.54669C6.90434 6.15243 9.37941 4.75672 11.854 3.35954C11.897 3.33018 11.9478 3.31452 11.9999 3.31459C12.0519 3.31467 12.1027 3.33049 12.1456 3.35997C14.6211 4.75466 17.0964 6.14984 19.5717 7.54551C19.6217 7.56738 19.6636 7.60434 19.6916 7.65121C19.7196 7.69808 19.7322 7.75252 19.7278 7.80693C19.7274 10.6023 19.7271 13.3979 19.7269 16.1938C19.7313 16.2422 19.721 16.2909 19.6972 16.3334C19.6735 16.3759 19.6375 16.4103 19.594 16.432C17.1564 17.8104 14.7174 19.1868 12.2772 20.5611C12.1606 20.6261 12.0226 20.7306 11.8863 20.6519C11.2472 20.2901 10.6159 19.9143 9.97894 19.5492C9.94638 19.5243 9.90713 19.5097 9.86621 19.5072C9.82529 19.5047 9.78457 19.5146 9.74926 19.5354C9.4687 19.6998 9.17339 19.8376 8.86718 19.947C8.72912 20.0029 8.55926 20.0188 8.46423 20.1469C8.58536 20.2787 8.73211 20.3844 8.8955 20.4575C9.64044 20.8888 10.3858 21.3198 11.1315 21.7503C11.3781 21.9052 11.6618 21.9912 11.9529 21.9993C12.2441 22.0074 12.532 21.9373 12.7869 21.7963C15.271 20.3957 17.7549 18.9944 20.2387 17.5924C20.4871 17.4627 20.6958 17.2684 20.8429 17.03C20.9899 16.7915 21.0699 16.5178 21.0744 16.2377V7.76347C21.0723 7.4937 20.9994 7.22922 20.8629 6.99651C20.7264 6.7638 20.5312 6.57104 20.2968 6.43754H20.2967Z"
            }),
            feature: JsSdkFeature
        },
        {
            id: 2,
            buttonTitle: "API Reference",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.4778 14.8829C13.7259 14.9562 12.9684 14.8183 12.2906 14.4847C12.137 14.3618 12.0103 14.2088 11.9182 14.035C11.8261 13.8613 11.7706 13.6705 11.7551 13.4745C11.7548 13.4451 11.7487 13.4162 11.7371 13.3892C11.7255 13.3622 11.7087 13.3379 11.6876 13.3175C11.6665 13.2971 11.6416 13.281 11.6143 13.2703C11.587 13.2596 11.5578 13.2544 11.5285 13.255C11.2119 13.2512 10.8954 13.252 10.5788 13.2546C10.5235 13.249 10.4682 13.2654 10.4249 13.3002C10.3816 13.3351 10.3537 13.3856 10.3474 13.4409C10.3294 13.7848 10.3875 14.1285 10.5177 14.4474C10.6479 14.7662 10.8469 15.0524 11.1005 15.2854C11.7407 15.785 12.518 16.0774 13.3288 16.1236C14.1735 16.2216 15.0284 16.1853 15.8618 16.0161C16.5018 15.8967 17.0885 15.5805 17.5401 15.1117C17.7897 14.8039 17.957 14.4377 18.0263 14.0474C18.0956 13.6572 18.0645 13.2558 17.9361 12.8809C17.8282 12.6166 17.6612 12.3805 17.4479 12.1908C17.2346 12.0011 16.9807 11.8627 16.7057 11.7864C15.4249 11.337 14.0414 11.3709 12.7357 11.0295C12.509 10.9581 12.232 10.8807 12.131 10.6407C12.0726 10.4718 12.0686 10.2889 12.1196 10.1176C12.1706 9.94632 12.2739 9.79535 12.4152 9.68589C12.8251 9.45159 13.292 9.33536 13.7639 9.35008C14.4045 9.28978 15.0502 9.38217 15.6481 9.61967C15.8277 9.7253 15.9822 9.86876 16.1008 10.0401C16.2194 10.2114 16.2993 10.4065 16.3349 10.6119C16.3366 10.6724 16.3609 10.7302 16.403 10.7738C16.4451 10.8174 16.502 10.8437 16.5625 10.8475C16.8768 10.8539 17.1912 10.8492 17.5056 10.8496C17.5601 10.8562 17.6151 10.8428 17.6606 10.812C17.706 10.7812 17.7388 10.735 17.7529 10.6819C17.7557 10.2579 17.6477 9.84057 17.4395 9.47118C17.2314 9.10178 16.9304 8.79318 16.5662 8.57593C15.5613 8.11211 14.4457 7.94142 13.348 8.0835V8.08342C12.5438 8.11639 11.7754 8.42513 11.1719 8.9578C10.8948 9.25641 10.7072 9.62683 10.6304 10.0269C10.5536 10.4269 10.5907 10.8405 10.7375 11.2204C10.8518 11.475 11.0199 11.7017 11.2302 11.885C11.4405 12.0683 11.6881 12.2038 11.9559 12.2822C13.2324 12.7433 14.6314 12.5953 15.9203 13.003C16.1715 13.0882 16.464 13.2185 16.5409 13.4981C16.5823 13.6656 16.5791 13.8411 16.5318 14.007C16.4845 14.173 16.3947 14.3237 16.2713 14.4442C15.7352 14.7772 15.107 14.9309 14.4778 14.8829ZM20.2967 6.43754C17.8045 5.0282 15.3117 3.62014 12.8183 2.21336C12.5681 2.07347 12.2862 2.00002 11.9996 2.00002C11.713 2.00002 11.4311 2.07347 11.1809 2.21336C8.69726 3.61589 6.21344 5.01836 3.72949 6.42076C3.48785 6.55247 3.28584 6.74643 3.14444 6.98253C3.00303 7.21863 2.92736 7.48827 2.92529 7.76347V16.2377C2.92927 16.5179 3.00901 16.7918 3.15605 17.0304C3.30309 17.2689 3.51196 17.4632 3.76049 17.5927C4.474 17.9811 5.16723 18.409 5.89367 18.7715C6.31296 18.9957 6.77865 19.1192 7.2539 19.1322C7.72916 19.1453 8.20093 19.0476 8.63189 18.8468C8.95436 18.6448 9.21676 18.36 9.39173 18.0221C9.5667 17.6842 9.64785 17.3056 9.62671 16.9257C9.63226 14.129 9.62756 11.3321 9.62884 8.5354C9.63371 8.50482 9.63206 8.47356 9.62401 8.44366C9.61596 8.41377 9.60168 8.38591 9.58211 8.36192C9.56254 8.33792 9.53813 8.31833 9.51046 8.30443C9.48279 8.29053 9.4525 8.28263 9.42157 8.28125C9.10418 8.27612 8.78631 8.27825 8.46893 8.2804C8.43955 8.27776 8.40993 8.28136 8.38204 8.29097C8.35414 8.30058 8.32859 8.31598 8.30706 8.33616C8.28553 8.35633 8.26851 8.38083 8.25712 8.40805C8.24572 8.43526 8.2402 8.46458 8.24093 8.49408C8.23666 11.2728 8.24179 14.0524 8.23837 16.8315C8.2391 17.0234 8.18115 17.2108 8.0723 17.3688C7.96345 17.5268 7.80889 17.6476 7.62937 17.7153C7.42265 17.7764 7.20536 17.7932 6.9917 17.7646C6.77804 17.736 6.57282 17.6626 6.38944 17.5493C5.72843 17.176 5.06743 16.8027 4.40644 16.4294C4.36265 16.4087 4.32626 16.375 4.30219 16.3329C4.27811 16.2909 4.26751 16.2424 4.2718 16.1941C4.2718 13.3983 4.2718 10.6025 4.2718 7.80689C4.26721 7.7525 4.27991 7.69806 4.30811 7.65133C4.33631 7.6046 4.37855 7.56797 4.4288 7.54669C6.90434 6.15243 9.37941 4.75672 11.854 3.35954C11.897 3.33018 11.9478 3.31452 11.9999 3.31459C12.0519 3.31467 12.1027 3.33049 12.1456 3.35997C14.6211 4.75466 17.0964 6.14984 19.5717 7.54551C19.6217 7.56738 19.6636 7.60434 19.6916 7.65121C19.7196 7.69808 19.7322 7.75252 19.7278 7.80693C19.7274 10.6023 19.7271 13.3979 19.7269 16.1938C19.7313 16.2422 19.721 16.2909 19.6972 16.3334C19.6735 16.3759 19.6375 16.4103 19.594 16.432C17.1564 17.8104 14.7174 19.1868 12.2772 20.5611C12.1606 20.6261 12.0226 20.7306 11.8863 20.6519C11.2472 20.2901 10.6159 19.9143 9.97894 19.5492C9.94638 19.5243 9.90713 19.5097 9.86621 19.5072C9.82529 19.5047 9.78457 19.5146 9.74926 19.5354C9.4687 19.6998 9.17339 19.8376 8.86718 19.947C8.72912 20.0029 8.55926 20.0188 8.46423 20.1469C8.58536 20.2787 8.73211 20.3844 8.8955 20.4575C9.64044 20.8888 10.3858 21.3198 11.1315 21.7503C11.3781 21.9052 11.6618 21.9912 11.9529 21.9993C12.2441 22.0074 12.532 21.9373 12.7869 21.7963C15.271 20.3957 17.7549 18.9944 20.2387 17.5924C20.4871 17.4627 20.6958 17.2684 20.8429 17.03C20.9899 16.7915 21.0699 16.5178 21.0744 16.2377V7.76347C21.0723 7.4937 20.9994 7.22922 20.8629 6.99651C20.7264 6.7638 20.5312 6.57104 20.2968 6.43754H20.2967Z"
            }),
            feature: ApiReferenceFeature
        }, 
    ]), categories = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "max-w-7xl mx-auto px-4 sm:px-6 md:px-8 ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: developers,
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Caption */.YS, {
                className: "text-color2",
                children: "Developer Experience"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* BigText */.y8, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Widont/* Widont */.X, {
                    children: "An MVP is a start but not an end."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Paragraph */.nv, {
                children: "Do you have developer support? You can fork our repo, customise as per your need. Build apps faster with our JS SDK. Or use REST API reference docs. GraphQL coming soon. A developer knows what he can do & the leverage he can get from an API product!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full px-2 sm:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs_esm/* Tab.Group */.O.Group, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_esm/* Tab.List */.O.List, {
                            className: "mt-2 flex p-1 items-center gap-7 ",
                            children: categories.map(function(category) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs_esm/* Tab */.O, {
                                    className: function(param) {
                                        var selected = param.selected;
                                        return classNames("w-[96px] py-2.5 text-sm leading-5 font-medium rounded-lg flex flex-col justify-center items-center gap-6  group outline-none", selected ? " transition duration-500 text-color2" : "text-gray-300  hover:text-gray-400");
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            class: "h-12 w-12",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            stroke: "currentColor",
                                            children: category.icon
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "",
                                            children: category.buttonTitle
                                        })
                                    ]
                                }, category);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_esm/* Tab.Panels */.O.Panels, {
                            className: "pt-10 xl:pt-0 mt-2",
                            children: categories.map(function(post, idx) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(tabs_esm/* Tab.Panel */.O.Panel, {
                                    className: classNames("bg-white rounded-xl p-3 block", "focus:outline-none "),
                                    children: post === null || post === void 0 ? void 0 : post.feature
                                }, idx);
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var tradly_home_DeveloperExperience = (DeveloperExperience);


/***/ }),

/***/ 3473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ tradly_home_Featuresstack; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Widont.js
var Widont = __webpack_require__(15253);
// EXTERNAL MODULE: ./src/components/home/common.js
var common = __webpack_require__(47262);
;// CONCATENATED MODULE: ./src/img/tradly/hero_icons/search.svg
var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 20,
    fill: "#1ED760"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.182 38.342l-3.523-3.524 6.49-6.49 3.523 3.523-6.49 6.49z",
    fill: "url(#search_svg__paint0_linear_1242_141)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.182 38.34l-3.523-3.523a1.932 1.932 0 000 2.733l.791.79a1.932 1.932 0 002.732 0z",
    fill: "url(#search_svg__paint1_linear_1242_141)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.066 29.569v6.89l4.606-4.608-3.523-3.523-1.162 1.162.079.079z",
    fill: "url(#search_svg__paint2_linear_1242_141)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.431 32.934l-3.366-3.366a1.167 1.167 0 010-1.65l.919-.919L23 32.016l-.918.918a1.167 1.167 0 01-1.65 0z",
    fill: "url(#search_svg__paint3_linear_1242_141)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.984 26.999l-.166.166v3.155l2.613 2.614a1.167 1.167 0 001.651 0l.918-.918-5.016-5.017z",
    fill: "url(#search_svg__paint4_linear_1242_141)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.823 33.354C33.996 33.354 39 28.35 39 22.177S33.996 11 27.823 11c-6.172 0-11.177 5.004-11.177 11.177s5.005 11.177 11.177 11.177z",
    fill: "url(#search_svg__paint5_linear_1242_141)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.823 31.586a9.409 9.409 0 100-18.817 9.409 9.409 0 000 18.817z",
    fill: "url(#search_svg__paint6_linear_1242_141)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.823 30.23a8.054 8.054 0 100-16.107 8.054 8.054 0 000 16.107z",
    fill: "url(#search_svg__paint7_linear_1242_141)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.487 38.797l-3.284-3.284a.692.692 0 11.978-.978l3.284 3.284a.692.692 0 11-.978.978z",
    fill: "url(#search_svg__paint8_linear_1242_141)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.719 15.246v.511c0 .388-.191.562-.506.562-.26 0-.432-.119-.484-.38-.207.17-.407.35-.6.544l-.085.085c.24.366.668.515 1.169.515.775 0 1.383-.36 1.383-1.326v-.96c-.3.13-.592.28-.877.449zM25.984 14.335v2.444c0 .18.219.27.438.27.22 0 .439-.09.439-.27v-2.598a7.947 7.947 0 00-.877.154zM29.85 14.382v1.375c0 .387-.19.562-.505.562-.314 0-.5-.175-.5-.562v-1.49c0-.027.001-.053.003-.078a7.908 7.908 0 00-.875-.064 1.988 1.988 0 00-.005.142v1.49c0 .967.601 1.326 1.377 1.326s1.383-.36 1.383-1.326v-1.094a7.958 7.958 0 00-.877-.281zM32.116 15.361v1.418c0 .18.22.27.439.27s.438-.09.438-.27v-.778a7.922 7.922 0 00-.877-.64zM21.108 17.73c-.18.268-.34.546-.483.83a.53.53 0 01.294-.074c.315 0 .506.174.506.562v1.49c0 .387-.191.561-.506.561-.314 0-.5-.174-.5-.561v-1.49l.001-.047a8.052 8.052 0 00-.615 2.422c.247.312.65.441 1.114.441.776 0 1.383-.36 1.383-1.326v-1.49c0-.887-.511-1.262-1.194-1.318zM24.18 17.71a.307.307 0 00-.164.04l-.742.45a.335.335 0 00-.163.297c0 .174.113.348.276.348.039 0 .09-.01.14-.045l.163-.1v2.86c0 .18.22.27.439.27s.438-.09.438-.27v-3.574c0-.169-.208-.276-.388-.276zM27.052 17.722c-.776 0-1.377.36-1.377 1.326v1.49c0 .966.601 1.326 1.377 1.326s1.382-.36 1.382-1.326v-1.49c0-.967-.607-1.326-1.382-1.326zm.505 2.816c0 .387-.19.561-.505.561s-.5-.174-.5-.561v-1.49c0-.388.185-.562.5-.562.314 0 .505.174.505.562v1.49zM30.312 17.71a.306.306 0 00-.163.04l-.742.45a.335.335 0 00-.163.297c0 .174.113.348.275.348.04 0 .09-.01.14-.045l.164-.1v2.86c0 .18.22.27.439.27.218 0 .438-.09.438-.27v-3.574c0-.169-.208-.276-.388-.276zM33.184 17.722c-.776 0-1.377.36-1.377 1.326v1.49c0 .966.601 1.326 1.377 1.326.775 0 1.383-.36 1.383-1.326v-1.49c0-.967-.608-1.326-1.383-1.326zm.506 2.816c0 .387-.191.561-.506.561s-.5-.174-.5-.561v-1.49c0-.388.185-.562.5-.562s.506.174.506.562v1.49zM20.34 22.491a.301.301 0 00-.163.04l-.386.234a8.031 8.031 0 00.937 3.228v-3.226c0-.169-.208-.276-.387-.276zM23.212 22.502c-.775 0-1.377.36-1.377 1.327v1.49c0 .966.602 1.326 1.377 1.326.776 0 1.383-.36 1.383-1.327v-1.49c0-.966-.607-1.326-1.383-1.326zm.507 2.816c0 .388-.192.562-.507.562-.314 0-.5-.174-.5-.562v-1.49c0-.387.186-.561.5-.561.316 0 .507.174.507.562v1.49zM26.473 22.491a.3.3 0 00-.163.04l-.742.45a.335.335 0 00-.163.297c0 .175.112.349.275.349.04 0 .09-.011.14-.045l.164-.102v2.861c0 .18.22.27.438.27.22 0 .439-.09.439-.27v-3.574c0-.169-.208-.276-.388-.276zM29.345 22.502c-.776 0-1.377.36-1.377 1.327v1.49c0 .966.601 1.326 1.377 1.326s1.383-.36 1.383-1.327v-1.49c0-.966-.607-1.326-1.383-1.326zm.506 2.816c0 .388-.191.562-.506.562-.314 0-.5-.174-.5-.562v-1.49c0-.387.186-.561.5-.561.315 0 .506.174.506.562v1.49zM32.605 22.491a.301.301 0 00-.163.04l-.742.45a.335.335 0 00-.163.297c0 .175.113.349.276.349.039 0 .09-.011.14-.045l.163-.102v2.861c0 .18.22.27.438.27.22 0 .439-.09.439-.27v-3.574c0-.169-.208-.276-.388-.276zM35.478 22.502c-.776 0-1.378.36-1.378 1.327v1.49c0 .575.214.936.55 1.133.156-.246.296-.498.42-.756a.665.665 0 01-.093-.378v-1.49c0-.387.185-.561.5-.561.126 0 .233.028.315.086.04-.27.065-.543.077-.816a2.04 2.04 0 00-.391-.035zM21.768 27.487c.115.132.235.26.36.385l.018.018a1.011 1.011 0 00-.378-.403zM24.18 27.271a.303.303 0 00-.164.04l-.742.45a.334.334 0 00-.163.297c0 .175.113.349.276.349.039 0 .09-.012.14-.045l.163-.101v.83c.285.171.578.323.877.454v-1.998c0-.169-.208-.276-.388-.276zM27.052 27.283c-.776 0-1.377.36-1.377 1.327v1.331c.29.08.582.143.877.19v-1.522c0-.387.185-.561.5-.561.314 0 .505.174.505.562v1.49c0 .045-.002.087-.007.127.293.01.588.004.881-.019a2.27 2.27 0 00.003-.109v-1.49c0-.966-.607-1.326-1.382-1.326zM30.312 27.271a.301.301 0 00-.163.04l-.742.45a.334.334 0 00-.163.297c0 .175.113.349.275.349.04 0 .09-.012.14-.045l.164-.101v1.719a8.05 8.05 0 00.877-.279v-2.154c0-.169-.208-.276-.388-.276zM33.184 27.283c-.776 0-1.377.36-1.377 1.327v.57c.302-.172.594-.365.876-.58.004-.38.189-.552.501-.552a.74.74 0 01.139.013 8.122 8.122 0 00.605-.63 1.72 1.72 0 00-.744-.148z",
    fill: "#E63950"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "search_svg__paint0_linear_1242_141",
    x1: 16.093,
    y1: 32.776,
    x2: 18.495,
    y2: 35.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B799D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07485E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "search_svg__paint1_linear_1242_141",
    x1: 12.143,
    y1: 37.857,
    x2: 12.73,
    y2: 37.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76E2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48B2E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "search_svg__paint2_linear_1242_141",
    x1: 17.335,
    y1: 33.818,
    x2: 21.684,
    y2: 26.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07485E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03232E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "search_svg__paint3_linear_1242_141",
    x1: 19.855,
    y1: 27.547,
    x2: 19.855,
    y2: 33.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48B2E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "search_svg__paint4_linear_1242_141",
    x1: 18.702,
    y1: 31.297,
    x2: 20.898,
    y2: 29.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5DBFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#8FC5E9",
    stopOpacity: 0.173
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454,
    stopColor: "#56A4C8",
    stopOpacity: 0.454
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696,
    stopColor: "#2D8DB1",
    stopOpacity: 0.696
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#147EA2",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B799D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "search_svg__paint5_linear_1242_141",
    x1: 27.815,
    y1: 12.935,
    x2: 27.815,
    y2: 33.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5E8FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "search_svg__paint6_linear_1242_141",
    x1: 27.796,
    y1: 29.948,
    x2: 27.796,
    y2: 12.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5E8FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "search_svg__paint7_linear_1242_141",
    x1: 27.815,
    y1: 15.52,
    x2: 27.815,
    y2: 30.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF637B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E63950"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "search_svg__paint8_linear_1242_141",
    x1: 13.904,
    y1: 36.096,
    x2: 12.58,
    y2: 37.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48B2E3"
  })))));
}
/* harmony default export */ var search = ("/_next/static/media/search.987f9a067607e38ba8dff3015344e2f0.svg");

// EXTERNAL MODULE: ./src/components/home/tradlyFeatures/feature.js
var feature = __webpack_require__(6597);
;// CONCATENATED MODULE: ./src/components/home/tradly-home/Featuresstack.jsx








function classNames() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(" ");
}
var Featuresstack = function() {
    var ref = (0,react.useState)([
        {
            id: 1,
            buttonTitle: "Styling",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.4199 15.54C7.23365 15.7274 7.12911 15.9808 7.12911 16.245C7.12911 16.5092 7.23365 16.7627 7.4199 16.95C7.51286 17.0437 7.62346 17.1181 7.74532 17.1689C7.86718 17.2197 7.99789 17.2458 8.1299 17.2458C8.26191 17.2458 8.39262 17.2197 8.51448 17.1689C8.63633 17.1181 8.74694 17.0437 8.8399 16.95C9.02615 16.7627 9.13069 16.5092 9.13069 16.245C9.13069 15.9808 9.02615 15.7274 8.8399 15.54C8.74694 15.4463 8.63633 15.3719 8.51448 15.3211C8.39262 15.2704 8.26191 15.2442 8.1299 15.2442C7.99789 15.2442 7.86718 15.2704 7.74532 15.3211C7.62346 15.3719 7.51286 15.4463 7.4199 15.54ZM7.4199 7.05002C7.23365 7.23738 7.12911 7.49083 7.12911 7.75502C7.12911 8.0192 7.23365 8.27265 7.4199 8.46002C7.51286 8.55375 7.62346 8.62814 7.74532 8.67891C7.86718 8.72968 7.99789 8.75582 8.1299 8.75582C8.26191 8.75582 8.39262 8.72968 8.51448 8.67891C8.63633 8.62814 8.74694 8.55375 8.8399 8.46002C9.02615 8.27265 9.13069 8.0192 9.13069 7.75502C9.13069 7.49083 9.02615 7.23738 8.8399 7.05002C8.74694 6.95629 8.63633 6.88189 8.51448 6.83113C8.39262 6.78036 8.26191 6.75422 8.1299 6.75422C7.99789 6.75422 7.86718 6.78036 7.74532 6.83113C7.62346 6.88189 7.51286 6.95629 7.4199 7.05002ZM12.3699 17.05C12.1721 17.05 11.9788 17.1087 11.8143 17.2185C11.6499 17.3284 11.5217 17.4846 11.446 17.6673C11.3703 17.8501 11.3505 18.0511 11.3891 18.2451C11.4277 18.4391 11.5229 18.6173 11.6628 18.7571C11.8026 18.897 11.9808 18.9922 12.1748 19.0308C12.3688 19.0694 12.5699 19.0496 12.7526 18.9739C12.9353 18.8982 13.0915 18.77 13.2014 18.6056C13.3112 18.4411 13.3699 18.2478 13.3699 18.05C13.3767 17.9145 13.3558 17.7791 13.3086 17.652C13.2614 17.5248 13.1888 17.4086 13.0953 17.3104C13.0017 17.2121 12.8892 17.134 12.7645 17.0806C12.6398 17.0273 12.5055 16.9998 12.3699 17V17.05ZM6.3699 11.05C6.17212 11.05 5.97878 11.1087 5.81433 11.2185C5.64988 11.3284 5.52171 11.4846 5.44602 11.6673C5.37033 11.8501 5.35053 12.0511 5.38911 12.2451C5.4277 12.4391 5.52294 12.6173 5.66279 12.7571C5.80264 12.897 5.98083 12.9922 6.17481 13.0308C6.36879 13.0694 6.56986 13.0496 6.75258 12.9739C6.93531 12.8982 7.09149 12.77 7.20137 12.6056C7.31125 12.4411 7.3699 12.2478 7.3699 12.05C7.37668 11.9145 7.35583 11.7791 7.30862 11.652C7.26141 11.5248 7.18883 11.4086 7.09529 11.3104C7.00174 11.2121 6.8892 11.134 6.76449 11.0806C6.63979 11.0273 6.50554 10.9998 6.3699 11V11.05ZM12.3699 5.05002C12.1721 5.05002 11.9788 5.10867 11.8143 5.21855C11.6499 5.32843 11.5217 5.48461 11.446 5.66733C11.3703 5.85006 11.3505 6.05113 11.3891 6.24511C11.4277 6.43909 11.5229 6.61727 11.6628 6.75712C11.8026 6.89698 11.9808 6.99222 12.1748 7.0308C12.3688 7.06939 12.5699 7.04958 12.7526 6.9739C12.9353 6.89821 13.0915 6.77004 13.2014 6.60559C13.3112 6.44114 13.3699 6.2478 13.3699 6.05002C13.3767 5.91455 13.3558 5.77912 13.3086 5.65196C13.2614 5.5248 13.1888 5.40858 13.0953 5.31036C13.0017 5.21214 12.8892 5.13398 12.7645 5.08062C12.6398 5.02727 12.5055 4.99985 12.3699 5.00002V5.05002ZM15.9099 7.10002C15.7695 7.23963 15.6736 7.4178 15.6346 7.61195C15.5955 7.80609 15.6149 8.00746 15.6905 8.19053C15.766 8.37361 15.8941 8.53014 16.0587 8.64028C16.2233 8.75042 16.4169 8.80922 16.6149 8.80922C16.8129 8.80922 17.0065 8.75042 17.1711 8.64028C17.3357 8.53014 17.4638 8.37361 17.5393 8.19053C17.6149 8.00746 17.6343 7.80609 17.5952 7.61195C17.5562 7.4178 17.4603 7.23963 17.3199 7.10002C17.1392 6.90697 16.8895 6.79334 16.6252 6.78397C16.361 6.7746 16.1038 6.87025 15.9099 7.05002V7.10002ZM22.2099 7.10002C21.2956 5.27231 19.8903 3.73544 18.1515 2.66172C16.4127 1.588 14.4091 1.0199 12.3655 1.02112C10.3219 1.02234 8.31902 1.59284 6.58148 2.66863C4.84395 3.74443 3.44045 5.28298 2.52838 7.11178C1.61631 8.94057 1.23172 10.9873 1.41774 13.0224C1.60377 15.0576 2.35305 17.0006 3.58157 18.6338C4.81008 20.2669 6.46926 21.5255 8.37304 22.2684C10.2768 23.0114 12.3499 23.2093 14.3599 22.84C14.8653 22.7449 15.3468 22.55 15.776 22.2667C16.2053 21.9834 16.5737 21.6174 16.8599 21.19C17.1682 20.7254 17.381 20.2041 17.4857 19.6564C17.5905 19.1087 17.5851 18.5456 17.4699 18C17.4069 17.6703 17.3735 17.3357 17.3699 17C17.3743 16.031 17.6602 15.0841 18.1928 14.2745C18.7254 13.465 19.4817 12.8276 20.3699 12.44C20.8488 12.2256 21.2786 11.9153 21.6329 11.5284C21.9872 11.1414 22.2585 10.6859 22.4299 10.19C22.6033 9.6833 22.6732 9.14693 22.6354 8.6127C22.5976 8.07847 22.4529 7.55728 22.2099 7.08002V7.10002ZM20.5099 9.54002C20.4246 9.77933 20.2921 9.99911 20.1203 10.1863C19.9486 10.3736 19.741 10.5244 19.5099 10.63C18.2799 11.1806 17.2349 12.0746 16.5006 13.2045C15.7662 14.3345 15.3736 15.6524 15.3699 17C15.3714 17.4701 15.4183 17.9389 15.5099 18.4C15.571 18.6818 15.575 18.973 15.5218 19.2564C15.4685 19.5397 15.3591 19.8096 15.1999 20.05C15.0652 20.2604 14.888 20.4403 14.6796 20.5781C14.4712 20.7159 14.2362 20.8085 13.9899 20.85C13.4558 20.9504 12.9134 21.0006 12.3699 21C11.1641 21.0006 9.97041 20.7589 8.85982 20.2892C7.74923 19.8195 6.74435 19.1314 5.90486 18.2658C5.06537 17.4002 4.40838 16.3747 3.97291 15.2502C3.53745 14.1258 3.33238 12.9253 3.3699 11.72C3.44751 9.47281 4.3589 7.33497 5.92653 5.72298C7.49415 4.11099 9.60573 3.1403 11.8499 3.00002H12.3599C14.0357 3.00044 15.678 3.4687 17.102 4.35208C18.526 5.23546 19.6751 6.49887 20.4199 8.00002C20.6491 8.475 20.6815 9.0213 20.5099 9.52002V9.54002ZM12.3699 11C12.1721 11 11.9788 11.0587 11.8143 11.1685C11.6499 11.2784 11.5217 11.4346 11.446 11.6173C11.3703 11.8001 11.3505 12.0011 11.3891 12.1951C11.4277 12.3891 11.5229 12.5673 11.6628 12.7071C11.8026 12.847 11.9808 12.9422 12.1748 12.9808C12.3688 13.0194 12.5699 12.9996 12.7526 12.9239C12.9353 12.8482 13.0915 12.72 13.2014 12.5556C13.3112 12.3911 13.3699 12.1978 13.3699 12C13.3699 11.7348 13.2645 11.4804 13.077 11.2929C12.8895 11.1054 12.6351 11 12.3699 11Z"
            }),
            feature: feature/* feature1 */.m
        },
        {
            id: 2,
            buttonTitle: "Features",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16 8.5C15.3078 8.5 14.6311 8.70527 14.0555 9.08986C13.4799 9.47444 13.0313 10.0211 12.7664 10.6606C12.5015 11.3001 12.4322 12.0039 12.5673 12.6828C12.7023 13.3617 13.0356 13.9854 13.5251 14.4749C14.0146 14.9644 14.6383 15.2977 15.3172 15.4327C15.9961 15.5678 16.6999 15.4985 17.3394 15.2336C17.9789 14.9687 18.5256 14.5201 18.9101 13.9445C19.2947 13.3689 19.5 12.6922 19.5 12C19.5 11.0717 19.1313 10.1815 18.4749 9.52513C17.8185 8.86875 16.9283 8.5 16 8.5ZM16 13.5C15.7033 13.5 15.4133 13.412 15.1666 13.2472C14.92 13.0824 14.7277 12.8481 14.6142 12.574C14.5006 12.2999 14.4709 11.9983 14.5288 11.7074C14.5867 11.4164 14.7296 11.1491 14.9393 10.9393C15.1491 10.7296 15.4164 10.5867 15.7074 10.5288C15.9983 10.4709 16.2999 10.5006 16.574 10.6142C16.8481 10.7277 17.0824 10.92 17.2472 11.1666C17.412 11.4133 17.5 11.7033 17.5 12C17.5 12.3978 17.342 12.7794 17.0607 13.0607C16.7794 13.342 16.3978 13.5 16 13.5ZM16 5H8C6.14348 5 4.36301 5.7375 3.05025 7.05025C1.7375 8.36301 1 10.1435 1 12C1 13.8565 1.7375 15.637 3.05025 16.9497C4.36301 18.2625 6.14348 19 8 19H16C17.8565 19 19.637 18.2625 20.9497 16.9497C22.2625 15.637 23 13.8565 23 12C23 10.1435 22.2625 8.36301 20.9497 7.05025C19.637 5.7375 17.8565 5 16 5ZM16 17H8C6.67392 17 5.40215 16.4732 4.46447 15.5355C3.52678 14.5979 3 13.3261 3 12C3 10.6739 3.52678 9.40215 4.46447 8.46447C5.40215 7.52678 6.67392 7 8 7H16C17.3261 7 18.5979 7.52678 19.5355 8.46447C20.4732 9.40215 21 10.6739 21 12C21 13.3261 20.4732 14.5979 19.5355 15.5355C18.5979 16.4732 17.3261 17 16 17Z"
            }),
            feature: feature/* feature1 */.m
        },
        {
            id: 3,
            buttonTitle: "Branding",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22 9.6699C21.9368 9.48699 21.822 9.32633 21.6693 9.2074C21.5167 9.08848 21.3328 9.0164 21.14 8.9999L15.45 8.1699L12.9 2.9999C12.8181 2.83083 12.6902 2.68824 12.5311 2.58847C12.3719 2.48871 12.1878 2.43579 12 2.43579C11.8121 2.43579 11.6281 2.48871 11.4689 2.58847C11.3097 2.68824 11.1819 2.83083 11.1 2.9999L8.54998 8.1599L2.85998 8.9999C2.6749 9.02621 2.5009 9.10386 2.35773 9.22406C2.21455 9.34425 2.10794 9.50218 2.04998 9.6799C1.99692 9.85358 1.99216 10.0384 2.03621 10.2146C2.08025 10.3908 2.17144 10.5516 2.29998 10.6799L6.42998 14.6799L5.42998 20.3599C5.3896 20.5483 5.40453 20.7444 5.47296 20.9245C5.54139 21.1047 5.66041 21.2612 5.81571 21.3753C5.971 21.4894 6.15595 21.5562 6.34831 21.5676C6.54066 21.5791 6.73224 21.5347 6.89998 21.4399L12 18.7699L17.1 21.4399C17.2403 21.5191 17.3988 21.5604 17.56 21.5599C17.7718 21.5607 17.9784 21.4941 18.15 21.3699C18.3051 21.2588 18.4252 21.1055 18.4961 20.9284C18.567 20.7512 18.5857 20.5574 18.55 20.3699L17.55 14.6899L21.68 10.6899C21.8244 10.5676 21.9311 10.4068 21.9877 10.2262C22.0444 10.0457 22.0486 9.85278 22 9.6699ZM15.85 13.6699C15.7342 13.7823 15.6474 13.9211 15.5969 14.0743C15.5464 14.2275 15.5337 14.3907 15.56 14.5499L16.28 18.7499L12.52 16.7499C12.3738 16.6776 12.213 16.64 12.05 16.64C11.8869 16.64 11.7261 16.6776 11.58 16.7499L7.81998 18.7499L8.53998 14.5499C8.56622 14.3907 8.55354 14.2275 8.50305 14.0743C8.45255 13.9211 8.36572 13.7823 8.24998 13.6699L5.24998 10.6699L9.45998 10.0599C9.62198 10.0374 9.77598 9.97544 9.90848 9.87955C10.041 9.78366 10.1479 9.65674 10.22 9.5099L12 5.6999L13.88 9.5199C13.952 9.66674 14.059 9.79366 14.1915 9.88955C14.324 9.98544 14.478 10.0474 14.64 10.0699L18.85 10.6799L15.85 13.6699Z"
            }),
            feature: feature/* feature1 */.m
        },
        {
            id: 4,
            buttonTitle: "Contents ",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129"
            }),
            feature: feature/* feature1 */.m
        }, 
    ]), categories = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "max-w-7xl mx-auto px-4 sm:px-6 md:px-8 ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: search,
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Caption */.YS, {
                className: "text-color9",
                children: "Features to tech stack"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* BigText */.y8, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Widont/* Widont */.X, {
                    children: "Principle on how we decide"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(common/* Paragraph */.nv, {
                as: "div",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            " ",
                            '"We try to look for these technical vectors that have a future, and that are headed up, and, you know, different pieces of technology go in cycles. They have their springs and summers, and autumns, and then they, you know, go to the graveyard of technology. And, so we try to pick the things that are in their springs... focus our energy on these technologies, which, we think, are in their ascendancy, and we think they’re going to be the right technologies for customers, and, you know what, they’re paying us to make those choices"'
                        ]
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: " - Steve Jobs"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            " ",
                            "We purposely picked few things to be matured/stable, few things to be emerging, and few things which are futuristic."
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var tradly_home_Featuresstack = (Featuresstack);


/***/ }),

/***/ 54597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ tradly_home_Modularity; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Widont.js
var Widont = __webpack_require__(15253);
// EXTERNAL MODULE: ./src/components/home/common.js
var common = __webpack_require__(47262);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/tabs/tabs.esm.js
var tabs_esm = __webpack_require__(66311);
;// CONCATENATED MODULE: ./src/img/tradly/hero_icons/launchwhatever.svg
var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function SvgLaunchwhatever(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 20,
    fill: "#D6512B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.142 15.916H28.38a.82.82 0 01-.82-.82v-1.395A2.704 2.704 0 0130.262 11a2.704 2.704 0 012.7 2.701v1.395a.82.82 0 01-.819.82zm-2.944-1.093h2.125v-1.122c0-.586-.477-1.063-1.062-1.063-.586 0-1.063.477-1.063 1.063v1.122z",
    fill: "#29376D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.592 24.283h-8.465a.82.82 0 01-.82-.82v-3.276l.002-.02v-.02l.273-5.055a.82.82 0 01.818-.78h7.721c.436 0 .796.341.819.776l.471 8.332c0 .546-.378.863-.819.863z",
    fill: "#FF645A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.592 24.283h-7.497v-9.97h7.026c.436 0 .796.34.819.775l.471 8.332c0 .546-.378.863-.819.863z",
    fill: "#FF3053"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.095 17.456v6.008a.82.82 0 01-.82.82h-8.488a.82.82 0 01-.81-.935l.383-6.008a.82.82 0 01.811-.704h8.105a.82.82 0 01.82.819z",
    fill: "#FABE2C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.345 39a2.458 2.458 0 100-4.916 2.458 2.458 0 000 4.916z",
    fill: "#29376D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.62 39a2.458 2.458 0 100-4.916 2.458 2.458 0 000 4.916z",
    fill: "#47568C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.954 22.877a.82.82 0 01-.818.86h-8.081a.821.821 0 01-.819-.86L22.4 19.6a.82.82 0 01.818-.779h7.754a.82.82 0 01.818.779l.164 3.277z",
    fill: "#4793FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.954 22.877a.82.82 0 01-.818.86h-4.04v-4.916h3.876a.82.82 0 01.818.779l.164 3.277z",
    fill: "#4756FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.407 23.124l-1.431 4.952a3.549 3.549 0 01-3.464 2.732H19.54c-.4-1.631-1.518-5.508-2.33-8.71h18.404a.82.82 0 01.793 1.026z",
    fill: "#DFE7F4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.407 23.124l-1.431 4.952a3.549 3.549 0 01-3.464 2.732h-4.417v-8.71h8.519a.82.82 0 01.793 1.026z",
    fill: "#B6C0D1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.62 37.362a.82.82 0 100-1.64.82.82 0 000 1.64z",
    fill: "#F0F7FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.345 37.362a.82.82 0 100-1.64.82.82 0 000 1.64z",
    fill: "#DFE7F4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.248 33.265a.82.82 0 01-.82.82h-11.74a3.16 3.16 0 01-3.085-2.441c-.282-.993-.177-.623-3.346-13.284a.813.813 0 00-.788-.614h-2.65a.82.82 0 010-1.639h2.65c1.123 0 2.1.76 2.377 1.849l.911 3.596a2004.17 2004.17 0 012.329 9.255c.048.195.086.351.111.46.165.694.778 1.179 1.492 1.179h11.74a.82.82 0 01.82.82z",
    fill: "#47568C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.248 33.264a.82.82 0 01-.82.82h-6.333v-1.639h6.334a.82.82 0 01.82.82z",
    fill: "#29376D"
  })));
}
/* harmony default export */ var launchwhatever = ("/_next/static/media/launchwhatever.723b2a28753590d068e52f0325b260a0.svg");

// EXTERNAL MODULE: ./src/components/home/tradlyFeatures/feature.js
var feature = __webpack_require__(6597);
// EXTERNAL MODULE: ./node_modules/swiper/swiper-react.mjs + 3 modules
var swiper_react = __webpack_require__(2261);
// EXTERNAL MODULE: ./node_modules/swiper/modules/index.mjs + 26 modules
var modules = __webpack_require__(99304);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/ListingDetails/ImagePart/ImagePart.jsx
/* eslint-disable react/prop-types */ 


// Import Swiper styles
// import Swiper core and required modules

 // install Swiper modules
var ImagePart = function(param) {
    var images = param.images;
    return /*#__PURE__*/ _jsx("div", {
        className: " ",
        children: images ? /*#__PURE__*/ _jsx(Swiper, {
            spaceBetween: 30,
            centeredSlides: true,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false
            },
            pagination: {
                clickable: true
            },
            modules: [
                Navigation,
                Autoplay,
                Pagination
            ],
            children: images === null || images === void 0 ? void 0 : images.map(function(image, i) {
                return /*#__PURE__*/ _jsx(SwiperSlide, {
                    className: "",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: " ",
                        children: /*#__PURE__*/ _jsx("img", {
                            src: image,
                            alt: "details image",
                            layout: "fill",
                            objectFit: "cover",
                            priority: true
                        })
                    })
                }, i);
            })
        }) : /*#__PURE__*/ _jsx("div", {
            className: "w-[400px] h-[400px] lg:w-[500px] lg:h-[500px] xl:w-[600px] xl:h-[600px] bg-[#3B3269] bg-opacity-[10%] animate-pulse"
        })
    });
};
/* harmony default export */ var ImagePart_ImagePart = ((/* unused pure expression or super */ null && (ImagePart)));

// EXTERNAL MODULE: ./src/components/home/tradlyFeatures/data/ListingDetailsData.js
var ListingDetailsData = __webpack_require__(66305);
;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/ListingDetails/EventsButtons/EventButtons.jsx
/* eslint-disable react/prop-types */ 

var EventButtons = function(param) {
    var listing_details = param.listing_details, selectedVariant = param.selectedVariant;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: " w-full flex justify-center items-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
            className: " w-[95%] h-[52px] bg-primary rounded-lg flex justify-center items-center ",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    width: "21",
                    height: "14",
                    viewBox: "0 0 21 14",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M7.5 5C7.23478 5 6.98043 5.10536 6.79289 5.29289C6.60536 5.48043 6.5 5.73478 6.5 6V8C6.5 8.26522 6.60536 8.51957 6.79289 8.70711C6.98043 8.89464 7.23478 9 7.5 9C7.76522 9 8.01957 8.89464 8.20711 8.70711C8.39464 8.51957 8.5 8.26522 8.5 8V6C8.5 5.73478 8.39464 5.48043 8.20711 5.29289C8.01957 5.10536 7.76522 5 7.5 5ZM19.5 6C19.7652 6 20.0196 5.89464 20.2071 5.70711C20.3946 5.51957 20.5 5.26522 20.5 5V1C20.5 0.734784 20.3946 0.48043 20.2071 0.292893C20.0196 0.105357 19.7652 0 19.5 0H1.5C1.23478 0 0.98043 0.105357 0.792893 0.292893C0.605357 0.48043 0.5 0.734784 0.5 1V5C0.5 5.26522 0.605357 5.51957 0.792893 5.70711C0.98043 5.89464 1.23478 6 1.5 6C1.76522 6 2.01957 6.10536 2.20711 6.29289C2.39464 6.48043 2.5 6.73478 2.5 7C2.5 7.26522 2.39464 7.51957 2.20711 7.70711C2.01957 7.89464 1.76522 8 1.5 8C1.23478 8 0.98043 8.10536 0.792893 8.29289C0.605357 8.48043 0.5 8.73478 0.5 9V13C0.5 13.2652 0.605357 13.5196 0.792893 13.7071C0.98043 13.8946 1.23478 14 1.5 14H19.5C19.7652 14 20.0196 13.8946 20.2071 13.7071C20.3946 13.5196 20.5 13.2652 20.5 13V9C20.5 8.73478 20.3946 8.48043 20.2071 8.29289C20.0196 8.10536 19.7652 8 19.5 8C19.2348 8 18.9804 7.89464 18.7929 7.70711C18.6054 7.51957 18.5 7.26522 18.5 7C18.5 6.73478 18.6054 6.48043 18.7929 6.29289C18.9804 6.10536 19.2348 6 19.5 6ZM18.5 4.18C17.9208 4.3902 17.4205 4.77363 17.0668 5.27816C16.7132 5.7827 16.5235 6.38388 16.5235 7C16.5235 7.61612 16.7132 8.2173 17.0668 8.72184C17.4205 9.22637 17.9208 9.6098 18.5 9.82V12H8.5C8.5 11.7348 8.39464 11.4804 8.20711 11.2929C8.01957 11.1054 7.76522 11 7.5 11C7.23478 11 6.98043 11.1054 6.79289 11.2929C6.60536 11.4804 6.5 11.7348 6.5 12H2.5V9.82C3.07915 9.6098 3.57954 9.22637 3.93316 8.72184C4.28678 8.2173 4.47648 7.61612 4.47648 7C4.47648 6.38388 4.28678 5.7827 3.93316 5.27816C3.57954 4.77363 3.07915 4.3902 2.5 4.18V2H6.5C6.5 2.26522 6.60536 2.51957 6.79289 2.70711C6.98043 2.89464 7.23478 3 7.5 3C7.76522 3 8.01957 2.89464 8.20711 2.70711C8.39464 2.51957 8.5 2.26522 8.5 2H18.5V4.18Z",
                        fill: "#FEFEFE"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: " text-xl text-white font-semibold ml-7 ",
                    children: "Book Now"
                })
            ]
        })
    });
};
/* harmony default export */ var EventsButtons_EventButtons = (EventButtons);

// EXTERNAL MODULE: ./src/img/tradly/favourite@3x.png
var favourite_3x = __webpack_require__(51574);
// EXTERNAL MODULE: ./src/img/tradly/heartIcon@3x.png
var heartIcon_3x = __webpack_require__(18356);
;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/ListingDetails/MainBox/MainBox.jsx
/* eslint-disable react/prop-types */ 





var MainBox = function(param) {
    var listing_details = param.listing_details, rating_data = param.rating_data, marketplace_type = param.marketplace_type;
    var stock_text = function(type, value) {
        if (type === 1) {
            return "Only ".concat(value, " products in stock");
        } else {
            return "".concat(value, " tickets left");
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: " w-full min-h-[250px] bg-white rounded p-[25px] relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: " w-5/6 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: " text-sm text-primary font-medium",
                        children: stock_text(marketplace_type, listing_details.stock)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: " mt-[9px] text-[30px] text-primary font-medium ",
                        children: listing_details.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: " mt-1 flex items-center flex-wrap",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-secondary text-base font-medium",
                                children: listing_details.list_price.currency
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: " text-black text-xl font-medium ml-[8px]",
                                children: listing_details.list_price.amount
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "flex justify-start items-center ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                width: "14",
                                height: "14",
                                viewBox: "0 0 14 13",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    d: "M6.99967 10.3892L3.78059 12.1687C3.4153 12.3706 2.97802 12.0625 3.04521 11.6506L3.66634 7.84278L1.01255 5.12285C0.728341 4.83156 0.892609 4.34088 1.29491 4.27941L4.93956 3.72256L6.54705 0.297803C6.72701 -0.0855992 7.27234 -0.0855992 7.4523 0.297803L9.05979 3.72256L12.7044 4.27941C13.1067 4.34088 13.271 4.83156 12.9868 5.12285L10.333 7.84278L10.9541 11.6506C11.0213 12.0625 10.584 12.3706 10.2188 12.1687L6.99967 10.3892Z",
                                    fill: "#FFBA49"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: " text-[#4F4F4F] font-medium text-base ml-[6px] ",
                                children: rating_data.rating_average
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: " text-secondary text-xs font-medium ml-[6px]",
                                children: [
                                    rating_data.rating_count,
                                    " Ratings"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: " absolute top-0 right-0 mt-6 mr-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: " h-[48px] w-[48px] relative cursor-pointer ",
                    children: listing_details.liked ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: favourite_3x/* default */.Z,
                        alt: "follow button",
                        layout: "fill",
                        objectFit: "cover"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: heartIcon_3x/* default */.Z,
                        alt: "follow button",
                        layout: "fill",
                        objectFit: "cover"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var MainBox_MainBox = (MainBox);

;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/ListingDetails/Variants/Variants.jsx
/* eslint-disable react/prop-types */ 


var Variants = function(param) {
    var variants = param.variants, listing_details = param.listing_details, marketplace_type = param.marketplace_type;
    var variant_title = function(type) {
        if (type === 1) {
            return "Select Variant";
        } else {
            return "Select Ticket";
        }
    };
    var variant_stock_text = function(type, value) {
        if (type === 1) {
            return "".concat(value, " products in stock");
        } else {
            return "".concat(value, " tickets left");
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-white rounded w-full min-h-[66px] p-[16px] ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-[#121212] text-sm font-semibold leading-4 ",
                children: variant_title(marketplace_type)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: " mt-5 ",
                children: variants.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full min-h-[90px] relative rounded-md overflow-hidden  flex items-center my-4 shadow-c-sm  border border-transparent cursor-pointer",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-[90px] w-[90px] relative",
                                children: item.images.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: item.images[0],
                                    layout: "fill"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: listing_details.images[0],
                                    layout: "fill"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: " ml-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: " text-sm text-primary font-normal",
                                        children: variant_stock_text(marketplace_type, item.stock)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-black font-semibold",
                                        children: item.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: " flex items-center ",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: " text-secondary font-normal text-xs",
                                                children: [
                                                    item.offer_price.currency,
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: " ml-2",
                                                children: [
                                                    item.offer_price.amount,
                                                    " "
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: " flex items-center text-xs ",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: item.offer_percent != 0 ? " line-through text-secondary font-normal" : "  text-secondary font-normal",
                                                children: item.list_price.formatted
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: " font-medium ml-2",
                                                children: [
                                                    "-",
                                                    item.offer_percent,
                                                    "%"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, item.id);
                })
            })
        ]
    });
};
/* harmony default export */ var Variants_Variants = (Variants);

// EXTERNAL MODULE: ./node_modules/next/dist/client/router.js
var router = __webpack_require__(90387);
;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/ListingDetails/ProductButtons/ProductButtons.jsx
/* eslint-disable react/prop-types */ 


var ProductButtons = function(param) {
    var listing_details = param.listing_details;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: " w-full flex justify-between items-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: " w-[45%] h-[52px] flex justify-center items-center border border-primary rounded-lg box-border ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: " text-base md:text-xl text-primary font-semibold ml-3",
                        children: "Add To Cart"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: " w-[50%] h-[52px] bg-primary rounded-lg flex justify-center items-center ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: " test-base md:text-xl text-white font-semibold ",
                        children: "Buy Now"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ProductButtons_ProductButtons = (ProductButtons);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/ListingDetails/StoreNameBox/StoreNameBox.jsx
/* eslint-disable react/prop-types */ 



var StoreNameBox = function(param) {
    var account = param.account, marketplace_type = param.marketplace_type;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: " bg-white rounded w-full min-h-[81px] flex justify-between items-center p-[16px] shadow-c-sm",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-start items-start w-[32px] h-[32px] rounded-full overflow-hidden relative",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: account === null || account === void 0 ? void 0 : account.images[0],
                            alt: "store Image",
                            layout: "fill",
                            objectFit: "cover"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: " block ml-[10px] cursor-pointer ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-base leading-4 text-[#121212] font-medium",
                            children: account === null || account === void 0 ? void 0 : account.name
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: " flex justify-center float-right",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: [
                        "  rounded w-[80px] h-[30px] flex justify-center items-center  text-xs leading-3 font-semibold border border-primary",
                        account.following ? "bg-primary text-white " : "bg-transparent text-primary ", 
                    ].join(" "),
                    children: account.following ? "Following" : "Follow"
                })
            })
        ]
    });
};
/* harmony default export */ var StoreNameBox_StoreNameBox = (StoreNameBox);

;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/ListingDetails/DescriptionPart/DescriptionPart.jsx
/* eslint-disable react/prop-types */ 

var DescriptionPart = function(param) {
    var description = param.description;
    return description !== undefined || description === "" ? /*#__PURE__*/ _jsxs("div", {
        className: " w-full min-h-[200px] bg-[#FFFFFF] rounded p-[24px]",
        children: [
            /*#__PURE__*/ _jsx("p", {
                className: "text-[#121212] text-sm font-semibold leading-4 ",
                children: "Description"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "ml-2 mt-4",
                children: /*#__PURE__*/ _jsx("article", {
                    className: "prose prose-red ",
                    children: description
                })
            })
        ]
    }) : /*#__PURE__*/ _jsx("div", {
        className: "border bg-[#3B3269] bg-opacity-[10%] shadow rounded-md p-4 w-full mx-auto",
        children: /*#__PURE__*/ _jsx("div", {
            className: "animate-pulse flex space-x-4",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "flex-1 space-y-4 py-1",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "h-4 bg-[#3B3269] bg-opacity-[20%] rounded w-3/4"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "space-y-2",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "h-4 bg-[#3B3269] bg-opacity-[20%] rounded"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "h-4 bg-[#3B3269] bg-opacity-[20%] rounded w-5/6"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var DescriptionPart_DescriptionPart = ((/* unused pure expression or super */ null && (DescriptionPart)));

;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/ListingDetails/AddressBox/AddressBox.jsx
/* eslint-disable react/prop-types */ 

var AddressBox = function(param) {
    var location = param.location;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: " bg-white rounded w-full min-h-[81px] flex justify-between p-[16px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex w-5/6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-start items-start",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            width: "18",
                            height: "22",
                            viewBox: "0 0 18 22",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M17.4604 8.62982C17.32 7.16873 16.8036 5.7689 15.9616 4.56664C15.1195 3.36437 13.9805 2.40065 12.6554 1.76931C11.3303 1.13798 9.86425 0.860541 8.40008 0.964024C6.93592 1.06751 5.5235 1.54838 4.30037 2.35982C3.24957 3.06247 2.36742 3.98912 1.71731 5.07321C1.0672 6.1573 0.665264 7.37193 0.540369 8.62982C0.417852 9.87948 0.575043 11.1407 1.00054 12.3221C1.42604 13.5035 2.10917 14.5753 3.00037 15.4598L8.30037 20.7698C8.39333 20.8636 8.50393 20.9379 8.62579 20.9887C8.74765 21.0395 8.87836 21.0656 9.01037 21.0656C9.14238 21.0656 9.27309 21.0395 9.39495 20.9887C9.51681 20.9379 9.62741 20.8636 9.72037 20.7698L15.0004 15.4598C15.8916 14.5753 16.5747 13.5035 17.0002 12.3221C17.4257 11.1407 17.5829 9.87948 17.4604 8.62982ZM13.6004 14.0498L9.00037 18.6498L4.40037 14.0498C3.72246 13.3719 3.20317 12.5521 2.87984 11.6496C2.5565 10.747 2.43715 9.78402 2.53037 8.82982C2.62419 7.86092 2.93213 6.92498 3.43194 6.08966C3.93175 5.25435 4.61093 4.54053 5.42037 3.99982C6.48131 3.29506 7.72668 2.91912 9.00037 2.91912C10.2741 2.91912 11.5194 3.29506 12.5804 3.99982C13.3874 4.53844 14.065 5.2491 14.5647 6.08076C15.0644 6.91242 15.3737 7.84442 15.4704 8.80982C15.5666 9.76725 15.4488 10.7341 15.1254 11.6404C14.8019 12.5466 14.281 13.3697 13.6004 14.0498ZM9.00037 4.99982C8.11035 4.99982 7.24032 5.26374 6.5003 5.75821C5.76028 6.25267 5.18351 6.95548 4.84291 7.77775C4.50232 8.60001 4.4132 9.50481 4.58684 10.3777C4.76047 11.2506 5.18905 12.0525 5.81839 12.6818C6.44773 13.3111 7.24955 13.7397 8.12246 13.9134C8.99538 14.087 9.90018 13.9979 10.7224 13.6573C11.5447 13.3167 12.2475 12.7399 12.742 11.9999C13.2364 11.2599 13.5004 10.3898 13.5004 9.49982C13.4977 8.30716 13.0228 7.1641 12.1794 6.32076C11.3361 5.47742 10.193 5.00246 9.00037 4.99982ZM9.00037 11.9998C8.50592 11.9998 8.02257 11.8532 7.61144 11.5785C7.20032 11.3038 6.87989 10.9133 6.69067 10.4565C6.50145 9.99971 6.45194 9.49705 6.54841 9.01209C6.64487 8.52714 6.88297 8.08169 7.2326 7.73205C7.58223 7.38242 8.02769 7.14432 8.51264 7.04786C8.9976 6.95139 9.50026 7.0009 9.95708 7.19012C10.4139 7.37934 10.8043 7.69977 11.079 8.1109C11.3537 8.52202 11.5004 9.00537 11.5004 9.49982C11.5004 10.1629 11.237 10.7987 10.7681 11.2676C10.2993 11.7364 9.66341 11.9998 9.00037 11.9998Z",
                                fill: "#121212"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "ml-[10px] w-5/6 ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-base leading-4 text-[#121212] font-semibold",
                                children: location.city + " " + location.country
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: " text-xs leading-4 font-medium text-secondary w-full mt-[2px]",
                                children: location.formatted_address
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: " flex justify-center float-right",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "28",
                    height: "27",
                    viewBox: "0 0 28 27",
                    fill: "none",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M26.1597 10.6734L16.8264 1.34003C16.0634 0.616021 15.0516 0.212402 13.9997 0.212402C12.9479 0.212402 11.9361 0.616021 11.1731 1.34003L1.83974 10.6734C1.09067 11.4234 0.669922 12.44 0.669922 13.5C0.669922 14.56 1.09067 15.5767 1.83974 16.3267L11.1731 25.66C11.9231 26.4091 12.9397 26.8298 13.9997 26.8298C15.0597 26.8298 16.0764 26.4091 16.8264 25.66L26.1597 16.3267C26.9088 15.5767 27.3295 14.56 27.3295 13.5C27.3295 12.44 26.9088 11.4234 26.1597 10.6734V10.6734ZM24.2797 14.4467L14.9464 23.78C14.8225 23.905 14.675 24.0042 14.5125 24.0719C14.35 24.1396 14.1758 24.1744 13.9997 24.1744C13.8237 24.1744 13.6494 24.1396 13.487 24.0719C13.3245 24.0042 13.177 23.905 13.0531 23.78L3.71974 14.4467C3.59476 14.3227 3.49557 14.1753 3.42788 14.0128C3.36019 13.8503 3.32534 13.676 3.32534 13.5C3.32534 13.324 3.36019 13.1497 3.42788 12.9873C3.49557 12.8248 3.59476 12.6773 3.71974 12.5534L13.0531 3.22003C13.177 3.09506 13.3245 2.99587 13.487 2.92818C13.6494 2.86048 13.8237 2.82563 13.9997 2.82563C14.1758 2.82563 14.35 2.86048 14.5125 2.92818C14.675 2.99587 14.8225 3.09506 14.9464 3.22003L24.2797 12.5534C24.4047 12.6773 24.5039 12.8248 24.5716 12.9873C24.6393 13.1497 24.6741 13.324 24.6741 13.5C24.6741 13.676 24.6393 13.8503 24.5716 14.0128C24.5039 14.1753 24.4047 14.3227 24.2797 14.4467ZM16.9464 9.8867C16.6953 9.63563 16.3548 9.49458 15.9997 9.49458C15.6447 9.49458 15.3041 9.63563 15.0531 9.8867C14.802 10.1378 14.6609 10.4783 14.6609 10.8334C14.6609 11.1884 14.802 11.529 15.0531 11.78L15.4531 12.1667H10.6664C10.3128 12.1667 9.97364 12.3072 9.72359 12.5572C9.47355 12.8073 9.33307 13.1464 9.33307 13.5V16.1667C9.33307 16.5203 9.47355 16.8595 9.72359 17.1095C9.97364 17.3596 10.3128 17.5 10.6664 17.5C11.02 17.5 11.3592 17.3596 11.6092 17.1095C11.8593 16.8595 11.9997 16.5203 11.9997 16.1667V14.8334H15.4531L15.0531 15.22C14.9281 15.344 14.8289 15.4914 14.7612 15.6539C14.6935 15.8164 14.6587 15.9907 14.6587 16.1667C14.6587 16.3427 14.6935 16.517 14.7612 16.6795C14.8289 16.8419 14.9281 16.9894 15.0531 17.1134C15.177 17.2383 15.3245 17.3375 15.487 17.4052C15.6494 17.4729 15.8237 17.5078 15.9997 17.5078C16.1758 17.5078 16.35 17.4729 16.5125 17.4052C16.675 17.3375 16.8225 17.2383 16.9464 17.1134L19.6131 14.4467C19.738 14.3227 19.8372 14.1753 19.9049 14.0128C19.9726 13.8503 20.0075 13.676 20.0075 13.5C20.0075 13.324 19.9726 13.1497 19.9049 12.9873C19.8372 12.8248 19.738 12.6773 19.6131 12.5534L16.9464 9.8867Z",
                        fill: "#15B790"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var AddressBox_AddressBox = (AddressBox);

// EXTERNAL MODULE: ./src/components/home/tradlyFeatures/common.module.scss
var common_module = __webpack_require__(27087);
var common_module_default = /*#__PURE__*/__webpack_require__.n(common_module);
;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/product_feature.js











var Product_feature = function() {
    var listing_details = ListingDetailsData.product.listing;
    var rating_data = ListingDetailsData.product.rating_data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (common_module_default()).bg_style,
        style: {
            paddingTop: "20px",
            paddingBottom: "20px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "grid md:grid-cols-2 gap-5 lg:p-10",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: " ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: " ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: " aspect-square",
                            src: listing_details === null || listing_details === void 0 ? void 0 : listing_details.images[0],
                            alt: "details image",
                            layout: "fill",
                            objectFit: "cover",
                            priority: true
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: " mt-6 md:mt-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: " shadow-lg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainBox_MainBox, {
                                listing_details: listing_details,
                                rating_data: rating_data,
                                marketplace_type: 1
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-6 shadow-lg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductButtons_ProductButtons, {
                                listing_details: listing_details,
                                marketplace_type: 1
                            })
                        }),
                        (listing_details === null || listing_details === void 0 ? void 0 : listing_details.account) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-6 shadow-lg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreNameBox_StoreNameBox, {
                                account: listing_details === null || listing_details === void 0 ? void 0 : listing_details.account
                            })
                        }),
                        (listing_details === null || listing_details === void 0 ? void 0 : listing_details.location) && Object.keys(listing_details === null || listing_details === void 0 ? void 0 : listing_details.location).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-6 shadow-lg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressBox_AddressBox, {
                                location: listing_details === null || listing_details === void 0 ? void 0 : listing_details.location
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var product_feature = (Product_feature);

;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/Event_feature.js













var Event_feature = function() {
    var ref;
    var listing_details = ListingDetailsData.event.listing;
    var rating_data = ListingDetailsData.event.rating_data;
    // const [selectedVariant, setSelectedVariant] = useState()
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (common_module_default()).bg_style,
        style: {
            paddingTop: "20px",
            paddingBottom: "20px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: " grid md:grid-cols-2 gap-5 sm:p-5 lg:p-10 ",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: " ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: " relative aspect-square",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: listing_details === null || listing_details === void 0 ? void 0 : listing_details.images[0],
                            alt: "details image",
                            layout: "fill",
                            objectFit: "cover",
                            priority: true
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: " mt-6 md:mt-0 ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: " shadow-lg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainBox_MainBox, {
                                listing_details: listing_details,
                                rating_data: rating_data,
                                marketplace_type: 2
                            })
                        }),
                        (listing_details === null || listing_details === void 0 ? void 0 : (ref = listing_details.variants) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-6 shadow-lg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Variants_Variants, {
                                variants: listing_details.variants,
                                listing_details: listing_details,
                                marketplace_type: 2
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-6 shadow-lg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventsButtons_EventButtons, {
                                listing_details: listing_details
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var tradlyFeatures_Event_feature = (Event_feature);

;// CONCATENATED MODULE: ./src/components/home/tradlyFeatures/Community_feature.js





var group_card = function(data) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: " md:w-[358px] min-h-[254px] bg-white shadow-lg rounded-md overflow-hidden",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: " relative w-full h-[167px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: data.img,
                    layout: "fill",
                    objectFit: "cover",
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-[24px] flex flex-wrap items-center justify-between px-[22px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: " font-semibold text-sm md:text-base text-black",
                                children: data.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: " font-normal text-sm text-gray-300",
                                children: [
                                    data.member,
                                    " members"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-3 mb-3 md:mt-0 md:mb-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "bg-primary py-1 px-3 rounded-md text-white text-sm md:text-base",
                            children: "Join Group"
                        })
                    })
                ]
            })
        ]
    });
};
var Community_feature = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (common_module_default()).bg_style,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full flex justify-center ",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "py-10 grid grid-cols-2 justify-center gap-5",
                children: ListingDetailsData.group.map(function(item) {
                    return group_card(item);
                })
            })
        })
    });
};
/* harmony default export */ var tradlyFeatures_Community_feature = (Community_feature);

;// CONCATENATED MODULE: ./src/components/home/tradly-home/Modularity.jsx











function classNames() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(" ");
}
var Modularity = function() {
    var ref = (0,react.useState)([
        {
            id: 1,
            buttonTitle: "Product",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
            }),
            feature: product_feature
        },
        {
            id: 2,
            buttonTitle: "Event",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"
            }),
            feature: tradlyFeatures_Event_feature
        },
        {
            id: 3,
            buttonTitle: "Community",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
            }),
            feature: tradlyFeatures_Community_feature
        }, 
    ]), categories = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "max-w-7xl mx-auto px-4 sm:px-6 md:px-8 ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: launchwhatever,
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Caption */.YS, {
                className: "text-color4",
                children: "Modularity is our mindset"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* BigText */.y8, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Widont/* Widont */.X, {
                    children: "Launch whatever you want."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Paragraph */.nv, {
                children: "Everyone has a unique dream. Our Builder empowers you to create without limits—craft Marketplaces, Commerce, Community Platforms, Discovery Apps, A User-generated directory, or SaaS Partner Portals effortlessly."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full sm:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs_esm/* Tab.Group */.O.Group, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_esm/* Tab.List */.O.List, {
                            className: " mt-10 flex p-1 items-center gap-7 ",
                            children: categories.map(function(category) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs_esm/* Tab */.O, {
                                    className: function(param) {
                                        var selected = param.selected;
                                        return classNames("w-[96px] py-2.5 text-sm leading-5 font-medium rounded-lg flex flex-col justify-center items-center gap-6  group outline-none", selected ? " transition duration-500 text-color4" : "text-gray-300  hover:text-gray-400");
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            class: "h-12 w-12",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            stroke: "currentColor",
                                            children: category.icon
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: " ",
                                            children: category.buttonTitle
                                        })
                                    ]
                                }, category);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_esm/* Tab.Panels */.O.Panels, {
                            className: "pt-10 xl:pt-0 max-h-[500px] overflow-auto md:max-h-full mt-2 ",
                            children: categories.map(function(post, idx) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(tabs_esm/* Tab.Panel */.O.Panel, {
                                    className: classNames("bg-white rounded-xl  md:p-3", "focus:outline-none  "),
                                    children: post === null || post === void 0 ? void 0 : post.feature
                                }, idx);
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var tradly_home_Modularity = (Modularity);


/***/ }),

/***/ 23354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ tradly_home_Opensource; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Widont.js
var Widont = __webpack_require__(15253);
// EXTERNAL MODULE: ./src/components/home/common.js
var common = __webpack_require__(47262);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/tabs/tabs.esm.js
var tabs_esm = __webpack_require__(66311);
;// CONCATENATED MODULE: ./src/img/tradly/hero_icons/budget.svg
var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function SvgBudget(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 20,
    fill: "#8C9EFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.839 17.655l-6.076-5.968c-.455-.455-1.09-.68-1.724-.684-.006 0-.01-.002-.016-.003h-.001c-.64 0-2.92.228-3.373.68l.664.96-5.111 5.022c-.7.7-1.202 1.764-1.202 2.9V36.54A2.464 2.464 0 0018.46 39h13.126a2.464 2.464 0 002.46-2.46V20.562a4.081 4.081 0 00-1.207-2.908zm-7.816 4.83a2.464 2.464 0 01-2.46-2.462c0-1.292 1.065-2.46 2.46-2.46a2.464 2.464 0 012.461 2.46 2.464 2.464 0 01-2.46 2.461z",
    fill: "#FF641A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.047 36.54V20.563a4.08 4.08 0 00-1.208-2.907l-6.076-5.968c-.455-.455-1.09-.68-1.724-.684-.006 0-.01-.002-.016-.003v6.562a2.464 2.464 0 012.461 2.461 2.464 2.464 0 01-2.46 2.461v16.516h6.562a2.464 2.464 0 002.46-2.461z",
    fill: "#F03800"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.125 33.204c0 .46-.36.82-.82.82h-6.563c-.46 0-.82-.36-.82-.82 0-.46.36-.82.82-.82h6.563c.46 0 .82.36.82.82zM29.125 29.923c0 .46-.36.82-.82.82h-6.563c-.46 0-.82-.36-.82-.82 0-.46.36-.82.82-.82h6.563c.46 0 .82.36.82.82z",
    fill: "#F03800"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.023 17.563h-4.921c-1.386 0-2.461-1.175-2.461-2.461a2.464 2.464 0 012.46-2.461h2.212l.977-.96c.453-.453 1.091-.681 1.732-.681h-4.92A4.106 4.106 0 0016 15.102c0 2.198 1.832 4.101 4.102 4.101h4.921a.82.82 0 100-1.64z",
    fill: "#5B362A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.844 18.383a.82.82 0 00-.82-.82v1.64a.82.82 0 00.82-.82z",
    fill: "#38211A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.125 33.203c0 .46-.36.82-.82.82h-3.282v-1.64h3.282c.46 0 .82.36.82.82zM28.305 30.742h-3.282v-1.64h3.282c.46 0 .82.36.82.82 0 .46-.36.82-.82.82z",
    fill: "#CD0000"
  })));
}
/* harmony default export */ var budget = ("/_next/static/media/budget.0480109dbcbd866069bc5f898f6e9715.svg");

// EXTERNAL MODULE: ./src/components/home/tradlyFeatures/feature.js
var feature = __webpack_require__(6597);
;// CONCATENATED MODULE: ./src/components/home/tradly-home/Opensource.jsx








function classNames() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(" ");
}
var Opensource = function() {
    var ref = (0,react.useState)([
        {
            id: 1,
            buttonTitle: "React",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "h-12 w-12",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M11.1031 10.4379C10.7972 10.6145 10.5505 10.8779 10.3943 11.1947C10.2381 11.5115 10.1793 11.8675 10.2254 12.2177C10.2715 12.5679 10.4204 12.8966 10.6533 13.1622C10.8862 13.4277 11.1926 13.6183 11.5338 13.7097C11.875 13.8011 12.2357 13.7893 12.5702 13.6757C12.9046 13.5622 13.1979 13.352 13.413 13.0717C13.628 12.7915 13.7551 12.4538 13.7781 12.1013C13.8012 11.7488 13.7193 11.3974 13.5427 11.0915C13.3058 10.6814 12.9157 10.3821 12.4582 10.2595C12.0007 10.137 11.5133 10.2011 11.1031 10.4379ZM19.1078 12.3756C18.9905 12.2416 18.8668 12.1073 18.7366 11.9725C18.8276 11.877 18.9156 11.7815 19.0006 11.686C20.6064 9.88177 21.2842 8.07233 20.6562 6.9845C20.054 5.9415 18.2628 5.63068 16.0203 6.06671C15.7994 6.10992 15.5797 6.15867 15.3613 6.21295C15.3195 6.06879 15.275 5.92546 15.2278 5.78295C14.4671 3.49042 13.2382 1.99921 11.9821 2C10.7777 2.00055 9.61367 3.39709 8.87108 5.5575C8.79802 5.77063 8.73043 5.98553 8.66832 6.20221C8.52227 6.16638 8.3756 6.13328 8.22832 6.10291C5.86232 5.61713 3.95665 5.93707 3.32988 7.02551C2.72888 8.06927 3.35741 9.77533 4.85839 11.4976C5.00725 11.668 5.16032 11.8346 5.31761 11.9974C5.13219 12.1884 4.95661 12.3793 4.79296 12.5691C3.32836 14.2671 2.73577 15.9453 3.3358 16.9845C3.95549 18.058 5.83434 18.4089 8.1212 17.9589C8.30653 17.9221 8.49084 17.8808 8.67412 17.8349C8.74126 18.0692 8.81491 18.3016 8.89507 18.5319C9.63439 20.6489 10.7919 22.0005 11.9921 22.0001C13.2315 21.9993 14.474 20.5472 15.2268 18.3413C15.2863 18.167 15.3425 17.986 15.3959 17.7996C15.6326 17.8585 15.8709 17.9107 16.1107 17.9564C18.3141 18.3732 20.0632 18.0454 20.6622 17.0054C21.2807 15.9311 20.643 14.1293 19.1077 12.3756H19.1078ZM4.07027 7.45184C4.45613 6.78184 6.01351 6.52045 8.05635 6.93984C8.18691 6.96669 8.3197 6.99669 8.45473 7.02984C8.25529 7.91211 8.11456 8.80662 8.03347 9.70751C7.29637 10.2261 6.5936 10.7918 5.92958 11.4011C5.78328 11.2498 5.64089 11.0948 5.5024 10.9362L5.50246 10.9363C4.21639 9.46057 3.70808 8.08081 4.07027 7.45184ZM7.95693 13.1799C7.44637 12.7933 6.97188 12.3973 6.54122 11.9989C6.97158 11.6031 7.44637 11.2083 7.95589 10.8228C7.93758 11.2155 7.92851 11.6086 7.92867 12.002C7.92894 12.3948 7.93836 12.7874 7.95693 13.1799ZM7.95632 17.1205C7.08958 17.3133 6.19478 17.3448 5.31661 17.2137C5.07588 17.1949 4.84154 17.127 4.62809 17.0141C4.41464 16.9013 4.22661 16.7458 4.07561 16.5574C3.71154 15.9267 4.18737 14.5794 5.43993 13.1271C5.5974 12.9451 5.76004 12.7679 5.92784 12.5954C6.59197 13.2079 7.29588 13.7759 8.03496 14.2955C8.11716 15.2079 8.25954 16.1138 8.46117 17.0075C8.29385 17.0493 8.12557 17.087 7.95632 17.1205ZM15.0575 9.08118C14.7221 8.86985 14.3825 8.6653 14.0388 8.46753C13.7006 8.27286 13.3584 8.08551 13.012 7.90546C13.605 7.65613 14.188 7.44318 14.7507 7.26965C14.8833 7.86795 14.9857 8.47256 15.0575 9.08118ZM9.67908 5.83521C10.3153 3.98407 11.2567 2.85468 11.9826 2.85437C12.7557 2.854 13.7601 4.07263 14.4169 6.052C14.4596 6.18103 14.4999 6.31079 14.5379 6.44128C13.675 6.70891 12.8308 7.03336 12.0108 7.41248C11.1941 7.0289 10.3526 6.70084 9.49177 6.43054C9.54931 6.23059 9.61175 6.03215 9.67908 5.83521ZM9.27871 7.259C9.86569 7.44379 10.443 7.65807 11.0084 7.901C10.3078 8.26253 9.62537 8.65633 8.96102 9.0824C9.04128 8.4444 9.14808 7.83313 9.27871 7.259ZM8.96248 14.9197C9.29378 15.1318 9.62992 15.336 9.97091 15.5324C10.3187 15.7327 10.6712 15.9245 11.0283 16.108C10.4586 16.3593 9.87631 16.5812 9.28383 16.7729C9.15169 16.1908 9.04372 15.5688 8.96248 14.9197ZM14.4182 18.0652C14.1521 18.9123 13.7324 19.7032 13.1801 20.3984L13.18 20.3985C13.0435 20.5976 12.8676 20.7667 12.6632 20.8952C12.4588 21.0236 12.2302 21.1088 11.9916 21.1455C11.2634 21.1459 10.334 20.0605 9.70169 18.25C9.62723 18.036 9.55873 17.82 9.49618 17.6021C10.3611 17.323 11.2061 16.9857 12.0254 16.5924C12.8521 16.9739 13.7031 17.3008 14.5727 17.5709C14.5252 17.7368 14.4737 17.9016 14.4182 18.0652ZM14.7804 16.741C14.2112 16.565 13.6198 16.3485 13.0183 16.0955C13.3574 15.917 13.699 15.7285 14.043 15.53C14.396 15.3262 14.7401 15.1172 15.0751 14.9031C15.0084 15.5204 14.91 16.1338 14.7804 16.741V16.741ZM15.2267 11.9983C15.2274 12.6056 15.2085 13.2124 15.1698 13.8187C14.6771 14.1522 14.157 14.4777 13.6158 14.7902C13.0769 15.1013 12.5429 15.3873 12.0191 15.6461C11.4679 15.3819 10.9273 15.0972 10.3973 14.7921C9.87034 14.4887 9.35545 14.1657 8.85264 13.8231C8.80668 13.2169 8.78353 12.6097 8.78318 12.0013L8.7833 12.0015C8.78288 11.3936 8.80553 10.7863 8.85124 10.1797C9.34379 9.84332 9.86015 9.51801 10.394 9.20978C10.9303 8.90009 11.471 8.61536 12.0087 8.3573C12.5531 8.62189 13.0877 8.90544 13.6125 9.20795C14.1391 9.51062 14.6555 9.83018 15.1615 10.1666C15.205 10.7762 15.2267 11.3868 15.2268 11.9983H15.2267ZM16.1834 6.90546C18.1048 6.53174 19.5534 6.78314 19.9163 7.41168C20.3029 8.0813 19.7489 9.56018 18.3625 11.118L18.3624 11.1181C18.2858 11.204 18.2064 11.2903 18.124 11.377C17.4485 10.7664 16.7322 10.2025 15.9801 9.68915C15.9042 8.79812 15.7687 7.91316 15.5746 7.04022C15.7815 6.98932 15.9844 6.9444 16.1834 6.90546ZM16.0536 10.7902C16.5609 11.1606 17.0487 11.5571 17.5149 11.978C17.0507 12.4059 16.5645 12.8092 16.0582 13.1863C16.0737 12.7904 16.0813 12.3942 16.0811 11.9979C16.0809 11.5952 16.0717 11.1926 16.0536 10.7902ZM19.9216 16.5789C19.5582 17.2101 18.1538 17.4733 16.2694 17.1168C16.0535 17.076 15.8319 17.0275 15.6047 16.9712C15.7941 16.087 15.9236 15.1911 15.9922 14.2894C16.743 13.7672 17.4571 13.1938 18.1292 12.5736C18.2469 12.6957 18.3587 12.8174 18.4649 12.9384V12.9383C19.0659 13.5919 19.5415 14.3505 19.8679 15.1763C19.9723 15.394 20.0309 15.6308 20.0402 15.872C20.0494 16.1133 20.0091 16.3539 19.9216 16.5789Z"
                })
            }),
            feature: "https://github.com/TRADLY-PLATFORM/Hummingbirds"
        },
        {
            id: 2,
            buttonTitle: "ReactNative",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "h-12 w-12",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M19.68 6.87994C18.661 6.34439 17.4727 6.22951 16.37 6.55994C16.3163 5.43841 15.833 4.38058 15.0203 3.60584C14.2076 2.83111 13.1278 2.39893 12.005 2.39893C10.8822 2.39893 9.80246 2.83111 8.98975 3.60584C8.17704 4.38058 7.69371 5.43841 7.64001 6.55994C6.5403 6.22875 5.35539 6.33257 4.33001 6.84994C3.57491 7.24683 2.95248 7.85604 2.53947 8.60245C2.12647 9.34886 1.94096 10.1998 2.00581 11.0504C2.07067 11.901 2.38306 12.714 2.90446 13.3892C3.42586 14.0643 4.13346 14.5721 4.94001 14.8499C4.4252 15.5825 4.14611 16.4546 4.14001 17.3499C4.14446 17.6013 4.16786 17.8521 4.21001 18.0999C4.37842 19.1155 4.90232 20.0381 5.68816 20.703C6.474 21.368 7.4706 21.7319 8.50001 21.7299C8.7131 21.7445 8.92693 21.7445 9.14001 21.7299C10.283 21.5499 11.3099 20.9287 12 19.9999C12.6973 20.9137 13.7232 21.5199 14.86 21.6899C15.0731 21.7045 15.2869 21.7045 15.5 21.6899C16.2982 21.689 17.0807 21.469 17.7625 21.0539C18.4442 20.6388 18.9989 20.0446 19.3661 19.3359C19.7333 18.6273 19.899 17.8314 19.845 17.0351C19.791 16.2388 19.5195 15.4726 19.06 14.8199C19.8705 14.5469 20.5828 14.0416 21.1083 13.3668C21.6337 12.692 21.9491 11.8776 22.0152 11.0249C22.0813 10.1723 21.8951 9.31898 21.4799 8.5713C21.0647 7.82362 20.4388 7.21456 19.68 6.81994V6.87994ZM10.34 4.93994C10.7868 4.51209 11.3814 4.27326 12 4.27326C12.6186 4.27326 13.2133 4.51209 13.66 4.93994C14.0011 5.28153 14.2327 5.71696 14.3253 6.19071C14.4179 6.66446 14.3673 7.15506 14.18 7.59994L13.92 8.18994L13.26 8.76994C12.8542 8.63066 12.429 8.55641 12 8.54994C11.4456 8.55047 10.8973 8.66625 10.39 8.88994L9.83001 7.59994C9.63594 7.15702 9.58079 6.66565 9.67185 6.19072C9.7629 5.7158 9.99588 5.27967 10.34 4.93994ZM4.24001 11.7799C4.01677 11.2887 3.96784 10.736 4.1013 10.2132C4.23477 9.69037 4.54264 9.22875 4.97402 8.90463C5.40541 8.5805 5.93448 8.41329 6.47378 8.43062C7.01308 8.44795 7.53033 8.64879 7.94001 8.99994L8.43001 9.42994L8.78001 10.2299C8.27906 10.9002 8.00573 11.7132 8.00001 12.5499C7.98815 12.6997 7.98815 12.8502 8.00001 12.9999H7.45001L6.61001 13.0799C6.12956 13.1306 5.64509 13.0333 5.2215 12.801C4.79792 12.5686 4.45546 12.2124 4.24001 11.7799ZM10.84 17.8599C10.7196 18.3938 10.419 18.8698 9.98863 19.2079C9.55831 19.546 9.02462 19.7254 8.47746 19.716C7.9303 19.7066 7.40309 19.509 6.98463 19.1563C6.56616 18.8037 6.282 18.3176 6.18001 17.7799C6.17043 17.6401 6.17043 17.4998 6.18001 17.3599C6.18364 16.9535 6.29353 16.555 6.49878 16.2042C6.70402 15.8533 6.99748 15.5623 7.35001 15.3599L7.86001 14.9999L8.77001 14.8999C9.34357 15.6978 10.1908 16.2567 11.15 16.4699L10.84 17.8599ZM12 14.5499C11.6045 14.5499 11.2178 14.4326 10.8889 14.2129C10.56 13.9931 10.3036 13.6808 10.1523 13.3153C10.0009 12.9499 9.96127 12.5477 10.0384 12.1598C10.1156 11.7718 10.3061 11.4154 10.5858 11.1357C10.8655 10.856 11.2219 10.6655 11.6098 10.5884C11.9978 10.5112 12.3999 10.5508 12.7654 10.7022C13.1308 10.8536 13.4432 11.1099 13.663 11.4388C13.8827 11.7677 14 12.1544 14 12.5499C14 13.0804 13.7893 13.5891 13.4142 13.9642C13.0392 14.3392 12.5304 14.5499 12 14.5499ZM17.82 17.7699C17.7168 18.3801 17.3782 18.9253 16.8769 19.2882C16.3756 19.6511 15.7519 19.8025 15.14 19.7099C14.6579 19.642 14.208 19.4284 13.8506 19.0978C13.4932 18.7672 13.2453 18.3353 13.14 17.8599L13 17.2599L13.21 16.3399C14.1325 16.0395 14.9144 15.414 15.41 14.5799L15.91 14.8799H16L16.66 15.2699C17.0888 15.5148 17.4309 15.887 17.6387 16.335C17.8465 16.7829 17.9099 17.2844 17.82 17.7699ZM19.76 11.7699C19.5633 12.1674 19.2599 12.5023 18.8838 12.7372C18.5076 12.9721 18.0735 13.0977 17.63 13.0999H17.39L16.75 12.9999L16 12.5899C15.9986 11.6177 15.6431 10.6792 15 9.94994L15.43 9.57994L16.06 8.99994C16.4709 8.63468 16.9959 8.42361 17.5453 8.40287C18.0946 8.38213 18.6341 8.55301 19.0713 8.88624C19.5085 9.21948 19.8163 9.69435 19.942 10.2295C20.0676 10.7647 20.0033 11.327 19.76 11.8199V11.7699Z"
                })
            }),
            feature: "https://github.com/TRADLY-PLATFORM/Wolverine"
        },
        {
            id: 3,
            buttonTitle: "Next Js ",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                class: "h-12 w-12",
                width: "45px",
                height: "45px",
                viewBox: "-1 -1 34 34 ",
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                stroke: "currentColor",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M23.749 30.005c-0.119 0.063-0.109 0.083 0.005 0.025 0.037-0.015 0.068-0.036 0.095-0.061 0-0.021 0-0.021-0.1 0.036zM23.989 29.875c-0.057 0.047-0.057 0.047 0.011 0.016 0.036-0.021 0.068-0.041 0.068-0.047 0-0.027-0.016-0.021-0.079 0.031zM24.145 29.781c-0.057 0.047-0.057 0.047 0.011 0.016 0.037-0.021 0.068-0.043 0.068-0.048 0-0.025-0.016-0.020-0.079 0.032zM24.303 29.688c-0.057 0.047-0.057 0.047 0.009 0.015 0.037-0.020 0.068-0.041 0.068-0.047 0-0.025-0.016-0.020-0.077 0.032zM24.516 29.547c-0.109 0.073-0.147 0.12-0.047 0.068 0.067-0.041 0.181-0.131 0.161-0.131-0.043 0.016-0.079 0.043-0.115 0.063zM14.953 0.011c-0.073 0.005-0.292 0.025-0.484 0.041-4.548 0.412-8.803 2.86-11.5 6.631-1.491 2.067-2.459 4.468-2.824 6.989-0.129 0.88-0.145 1.14-0.145 2.333 0 1.192 0.016 1.448 0.145 2.328 0.871 6.011 5.147 11.057 10.943 12.927 1.043 0.333 2.136 0.563 3.381 0.704 0.484 0.052 2.577 0.052 3.061 0 2.152-0.24 3.969-0.771 5.767-1.688 0.276-0.14 0.328-0.177 0.291-0.208-0.88-1.161-1.744-2.323-2.609-3.495l-2.557-3.453-3.203-4.745c-1.068-1.588-2.14-3.172-3.229-4.744-0.011 0-0.025 2.109-0.031 4.681-0.011 4.505-0.011 4.688-0.068 4.792-0.057 0.125-0.151 0.229-0.276 0.287-0.099 0.047-0.188 0.057-0.661 0.057h-0.541l-0.141-0.088c-0.088-0.057-0.161-0.136-0.208-0.229l-0.068-0.141 0.005-6.271 0.011-6.271 0.099-0.125c0.063-0.077 0.141-0.14 0.229-0.187 0.131-0.063 0.183-0.073 0.724-0.073 0.635 0 0.74 0.025 0.907 0.208 1.296 1.932 2.588 3.869 3.859 5.812 2.079 3.152 4.917 7.453 6.312 9.563l2.537 3.839 0.125-0.083c1.219-0.813 2.328-1.781 3.285-2.885 2.016-2.308 3.324-5.147 3.767-8.177 0.129-0.88 0.145-1.141 0.145-2.333 0-1.193-0.016-1.448-0.145-2.328-0.871-6.011-5.147-11.057-10.943-12.928-1.084-0.343-2.199-0.577-3.328-0.697-0.303-0.031-2.371-0.068-2.631-0.041zM21.5 9.688c0.151 0.072 0.265 0.208 0.317 0.364 0.027 0.084 0.032 1.823 0.027 5.74l-0.011 5.624-0.989-1.52-0.995-1.521v-4.083c0-2.647 0.011-4.131 0.025-4.204 0.047-0.167 0.161-0.307 0.313-0.395 0.124-0.063 0.172-0.068 0.667-0.068 0.463 0 0.541 0.005 0.645 0.063z"
                })
            }),
            feature: "https://github.com/TRADLY-PLATFORM/Butterflies"
        },
        {
            id: 4,
            buttonTitle: "Flutter  ",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "h-12 w-12",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 48 48",
                width: "48px",
                height: "48px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M 27 3 A 1.0001 1.0001 0 0 0 26.292969 3.2929688 L 5.2929688 24.292969 A 1.0001 1.0001 0 0 0 5.2929688 25.707031 L 11.292969 31.707031 A 1.0001 1.0001 0 0 0 12.707031 31.707031 L 39.707031 4.7070312 A 1.0001 1.0001 0 0 0 39 3 L 27 3 z M 27.414062 5 L 36.585938 5 L 12 29.585938 L 7.4140625 25 L 27.414062 5 z M 28 22 A 1.0001 1.0001 0 0 0 27.292969 22.292969 L 15.292969 34.292969 A 1.0001 1.0001 0 0 0 15.292969 35.707031 L 21.292969 41.707031 L 27.292969 47.707031 A 1.0001 1.0001 0 0 0 28 48 L 40 48 A 1.0001 1.0001 0 0 0 40.707031 46.292969 L 29.414062 35 L 40.707031 23.707031 A 1.0001 1.0001 0 0 0 40 22 L 28 22 z M 28.414062 24 L 37.585938 24 L 22 39.585938 L 17.414062 35 L 28.414062 24 z M 28 36.414062 L 37.585938 46 L 28.414062 46 L 23.414062 41 L 28 36.414062 z"
                })
            }),
            feature: "https://github.com/TRADLY-PLATFORM/kittiwake"
        }, 
    ]), categories = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "max-w-7xl mx-auto px-4 sm:px-6 md:px-8 ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: budget,
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Caption */.YS, {
                className: "text-color7",
                children: "Open-source Repositories"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* BigText */.y8, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Widont/* Widont */.X, {
                    children: "Cannot afford a budget? Don’t worry."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Paragraph */.nv, {
                children: "Pay only for the Headless API. Fork our open-source repositories and learn customization through YouTube videos. Customize both your app and web experiences using our server-configurable options in the Admin Panel. Developers can use the JS SDK or API reference to build tailored applications."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full px-2 sm:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_esm/* Tab.Group */.O.Group, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_esm/* Tab.List */.O.List, {
                        className: "mt-2 flex p-1 items-center gap-7 ",
                        children: categories.map(function(category) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_esm/* Tab */.O, {
                                className: function(param) {
                                    var selected = param.selected;
                                    return classNames("w-[96px] py-2.5 text-sm leading-5 font-medium rounded-lg flex  flex-col justify-center items-center   group outline-none", selected ? " transition duration-500  text-color7" : "text-gray-300  hover:text-gray-400");
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    href: category.feature,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    className: " flex flex-col justify-center items-center gap-6 ",
                                    children: [
                                        category.icon,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "",
                                            children: category.buttonTitle
                                        })
                                    ]
                                })
                            }, category);
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var tradly_home_Opensource = (Opensource);


/***/ }),

/***/ 66305:
/***/ (function(module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _interopRequireDefault = (__webpack_require__(92648)/* ["default"] */ .Z);
var _airJordan1MidSeShoesHHltxpJpeg = /*#__PURE__*/ _interopRequireDefault(__webpack_require__(99996));
var _account1Png = /*#__PURE__*/ _interopRequireDefault(__webpack_require__(49609));
var _productconferenceJpg = /*#__PURE__*/ _interopRequireDefault(__webpack_require__(24759));
var _nordicDesignJpg = /*#__PURE__*/ _interopRequireDefault(__webpack_require__(16162));
var _turkishDriedFruitsJpeg = /*#__PURE__*/ _interopRequireDefault(__webpack_require__(71643));
var _yemenCoffeeJpeg = /*#__PURE__*/ _interopRequireDefault(__webpack_require__(98634));
var _organicAfricaSVegJpg = /*#__PURE__*/ _interopRequireDefault(__webpack_require__(82750));
var _nordicFlowersJpeg = /*#__PURE__*/ _interopRequireDefault(__webpack_require__(50706));
module.exports = {
    product: {
        listing: {
            id: 9883,
            account_id: 2714,
            list_price: {
                amount: 80,
                currency: "AUD",
                formatted: "A$ 80"
            },
            category_id: [
                73
            ],
            currency_id: 9,
            offer_percent: 0,
            stock: 300,
            shipping_charges: {
                amount: 100,
                currency: "AUD",
                formatted: "A$ 100"
            },
            images: [
                _airJordan1MidSeShoesHHltxpJpeg.default
            ],
            offer_price: {
                amount: 15,
                currency: "AUD",
                formatted: "A$15"
            },
            location: {
                city: "Dereel",
                state: "Victoria",
                country: "Australia",
                locality: "Essendon",
                postcode: "3040",
                country_code: "au",
                formatted_address: "67 Sunraysia Road,  Dereel, Victoria, Australia"
            },
            type: "listings",
            sold: false,
            active: true,
            status: 2,
            created_at: 1640139333,
            start_at: 1640139333,
            end_at: 1640139333,
            likes: 1,
            max_quantity: 300,
            account: {
                id: 2714,
                name: "Jay Z shop",
                location: {
                    city: "Dereel",
                    state: "Victoria",
                    country: "Australia",
                    locality: "Essendon",
                    postcode: "3040",
                    country_code: "au",
                    formatted_address: "67 Sunraysia Road,  Dereel, Victoria, Australia"
                },
                unique_name: "",
                description: "@monrose.indoor.plants on Instagram or www.Monroseindoorplants.com.au",
                total_followers: 22,
                total_listings: 49,
                images: [
                    _account1Png.default,
                    _account1Png.default
                ],
                type: "accounts",
                active: true,
                status: 2,
                following: false,
                user: {
                    email_verified: true,
                    blocked: false,
                    id: "6daa9f01-8540-4c2f-a886-6bc36ac1bb74",
                    first_name: "Monrose",
                    last_name: "Indoor Plants",
                    profile_pic: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/64375/d7a90962-c1ea-4ddd-9424-3cf0529fa173.png",
                    email: "nikitat484@gmail.com",
                    mobile: "",
                    dial_code: "",
                    created_at: 1630452449,
                    updated_at: 1630628078
                },
                category_id: []
            },
            categories: [
                {
                    id: 73,
                    parent: 0,
                    type: "listings",
                    active: true,
                    image_path: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/67018/28edeebc-3402-428e-921c-850b09afb1fb.png",
                    order_by: 5,
                    sub_category: [],
                    name: "Pots & Accessories",
                    hierarchy: [
                        {
                            id: 73,
                            name: "Pots & Accessories",
                            level: 1
                        }, 
                    ]
                }, 
            ],
            distance: 0,
            in_cart: false,
            liked: false,
            title: "AIR JORDAN 1 MID SE",
            description: "",
            coordinates: {
                latitude: -37.755963,
                longitude: 144.91617790401142
            },
            attributes: [
                {
                    id: 8,
                    type: "listings",
                    field_type: 1,
                    optional: false,
                    private: false,
                    active: true,
                    order_by: 0,
                    name: "Posts to Quarantine States?",
                    categories: [
                        {
                            id: 65,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/20384/78a1e20a-7700-4459-b61d-5236f1d9e49b.jpg",
                            order_by: 1,
                            sub_category: [],
                            name: "Small",
                            hierarchy: [
                                {
                                    id: 65,
                                    name: "Small",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 66,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/70705/769b998b-f4a5-4858-b52f-bebbfac2736f.png",
                            order_by: 2,
                            sub_category: [],
                            name: "Large",
                            hierarchy: [
                                {
                                    id: 66,
                                    name: "Large",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 72,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/27574/fd36f4b6-52e7-4d8a-ab55-f430af15323a.png",
                            order_by: 3,
                            sub_category: [],
                            name: "Cuttings",
                            hierarchy: [
                                {
                                    id: 72,
                                    name: "Cuttings",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 70,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/10089/82c7a87c-0ccc-4bbf-b5d5-e32ba6c05631.png",
                            order_by: 4,
                            sub_category: [],
                            name: "Cacti & Succulents",
                            hierarchy: [
                                {
                                    id: 70,
                                    name: "Cacti & Succulents",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 73,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/67018/28edeebc-3402-428e-921c-850b09afb1fb.png",
                            order_by: 5,
                            sub_category: [],
                            name: "Pots & Accessories",
                            hierarchy: [
                                {
                                    id: 73,
                                    name: "Pots & Accessories",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 75,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/38943/653a0f8d-eee6-4b8b-918d-1c9e720576c1.png",
                            order_by: 8,
                            sub_category: [],
                            name: "Unicorn (Rarer Plants)",
                            hierarchy: [
                                {
                                    id: 75,
                                    name: "Unicorn (Rarer Plants)",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 76,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/41769/dc1105f2-26be-4e21-b40e-88da631e7496.png",
                            order_by: 8,
                            sub_category: [],
                            name: "Climbers",
                            hierarchy: [
                                {
                                    id: 76,
                                    name: "Climbers",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 69,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/94603/2ccee3b6-9411-4389-842b-600713b6459f.png",
                            order_by: 9,
                            sub_category: [],
                            name: "Low Light",
                            hierarchy: [
                                {
                                    id: 69,
                                    name: "Low Light",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 77,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/72936/cf235659-66e3-4589-b73c-70a41b1e1a49.png",
                            order_by: 10,
                            sub_category: [],
                            name: "Low Maintenance ",
                            hierarchy: [
                                {
                                    id: 77,
                                    name: "Low Maintenance ",
                                    level: 1
                                }, 
                            ]
                        }, 
                    ],
                    values: [
                        {
                            id: 13,
                            active: true,
                            name: "Yes"
                        }, 
                    ]
                },
                {
                    id: 46,
                    type: "listings",
                    field_type: 1,
                    optional: false,
                    private: false,
                    active: true,
                    order_by: 0,
                    name: "Postage available?",
                    categories: [
                        {
                            id: 65,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/20384/78a1e20a-7700-4459-b61d-5236f1d9e49b.jpg",
                            order_by: 1,
                            sub_category: [],
                            name: "Small",
                            hierarchy: [
                                {
                                    id: 65,
                                    name: "Small",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 66,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/70705/769b998b-f4a5-4858-b52f-bebbfac2736f.png",
                            order_by: 2,
                            sub_category: [],
                            name: "Large",
                            hierarchy: [
                                {
                                    id: 66,
                                    name: "Large",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 72,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/27574/fd36f4b6-52e7-4d8a-ab55-f430af15323a.png",
                            order_by: 3,
                            sub_category: [],
                            name: "Cuttings",
                            hierarchy: [
                                {
                                    id: 72,
                                    name: "Cuttings",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 70,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/10089/82c7a87c-0ccc-4bbf-b5d5-e32ba6c05631.png",
                            order_by: 4,
                            sub_category: [],
                            name: "Cacti & Succulents",
                            hierarchy: [
                                {
                                    id: 70,
                                    name: "Cacti & Succulents",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 73,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/67018/28edeebc-3402-428e-921c-850b09afb1fb.png",
                            order_by: 5,
                            sub_category: [],
                            name: "Pots & Accessories",
                            hierarchy: [
                                {
                                    id: 73,
                                    name: "Pots & Accessories",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 75,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/38943/653a0f8d-eee6-4b8b-918d-1c9e720576c1.png",
                            order_by: 8,
                            sub_category: [],
                            name: "Unicorn (Rarer Plants)",
                            hierarchy: [
                                {
                                    id: 75,
                                    name: "Unicorn (Rarer Plants)",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 76,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/41769/dc1105f2-26be-4e21-b40e-88da631e7496.png",
                            order_by: 8,
                            sub_category: [],
                            name: "Climbers",
                            hierarchy: [
                                {
                                    id: 76,
                                    name: "Climbers",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 69,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/94603/2ccee3b6-9411-4389-842b-600713b6459f.png",
                            order_by: 9,
                            sub_category: [],
                            name: "Low Light",
                            hierarchy: [
                                {
                                    id: 69,
                                    name: "Low Light",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 77,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/72936/cf235659-66e3-4589-b73c-70a41b1e1a49.png",
                            order_by: 10,
                            sub_category: [],
                            name: "Low Maintenance ",
                            hierarchy: [
                                {
                                    id: 77,
                                    name: "Low Maintenance ",
                                    level: 1
                                }, 
                            ]
                        }, 
                    ],
                    values: [
                        {
                            id: 166,
                            active: true,
                            name: "Yes, for a fee"
                        }, 
                    ]
                },
                {
                    id: 47,
                    type: "listings",
                    field_type: 1,
                    optional: false,
                    private: false,
                    active: true,
                    order_by: 0,
                    name: "Pickup available? ",
                    categories: [
                        {
                            id: 65,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/20384/78a1e20a-7700-4459-b61d-5236f1d9e49b.jpg",
                            order_by: 1,
                            sub_category: [],
                            name: "Small",
                            hierarchy: [
                                {
                                    id: 65,
                                    name: "Small",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 66,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/70705/769b998b-f4a5-4858-b52f-bebbfac2736f.png",
                            order_by: 2,
                            sub_category: [],
                            name: "Large",
                            hierarchy: [
                                {
                                    id: 66,
                                    name: "Large",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 72,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/27574/fd36f4b6-52e7-4d8a-ab55-f430af15323a.png",
                            order_by: 3,
                            sub_category: [],
                            name: "Cuttings",
                            hierarchy: [
                                {
                                    id: 72,
                                    name: "Cuttings",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 70,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/10089/82c7a87c-0ccc-4bbf-b5d5-e32ba6c05631.png",
                            order_by: 4,
                            sub_category: [],
                            name: "Cacti & Succulents",
                            hierarchy: [
                                {
                                    id: 70,
                                    name: "Cacti & Succulents",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 73,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/67018/28edeebc-3402-428e-921c-850b09afb1fb.png",
                            order_by: 5,
                            sub_category: [],
                            name: "Pots & Accessories",
                            hierarchy: [
                                {
                                    id: 73,
                                    name: "Pots & Accessories",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 75,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/38943/653a0f8d-eee6-4b8b-918d-1c9e720576c1.png",
                            order_by: 8,
                            sub_category: [],
                            name: "Unicorn (Rarer Plants)",
                            hierarchy: [
                                {
                                    id: 75,
                                    name: "Unicorn (Rarer Plants)",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 76,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/41769/dc1105f2-26be-4e21-b40e-88da631e7496.png",
                            order_by: 8,
                            sub_category: [],
                            name: "Climbers",
                            hierarchy: [
                                {
                                    id: 76,
                                    name: "Climbers",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 69,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/94603/2ccee3b6-9411-4389-842b-600713b6459f.png",
                            order_by: 9,
                            sub_category: [],
                            name: "Low Light",
                            hierarchy: [
                                {
                                    id: 69,
                                    name: "Low Light",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 77,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/72936/cf235659-66e3-4589-b73c-70a41b1e1a49.png",
                            order_by: 10,
                            sub_category: [],
                            name: "Low Maintenance ",
                            hierarchy: [
                                {
                                    id: 77,
                                    name: "Low Maintenance ",
                                    level: 1
                                }, 
                            ]
                        }, 
                    ],
                    values: [
                        {
                            id: 168,
                            active: true,
                            name: "Yes"
                        }, 
                    ]
                },
                {
                    id: 56,
                    type: "listings",
                    field_type: 1,
                    optional: false,
                    private: false,
                    active: true,
                    order_by: 0,
                    name: "Delivery Available? ",
                    categories: [
                        {
                            id: 65,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/20384/78a1e20a-7700-4459-b61d-5236f1d9e49b.jpg",
                            order_by: 1,
                            sub_category: [],
                            name: "Small",
                            hierarchy: [
                                {
                                    id: 65,
                                    name: "Small",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 66,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/70705/769b998b-f4a5-4858-b52f-bebbfac2736f.png",
                            order_by: 2,
                            sub_category: [],
                            name: "Large",
                            hierarchy: [
                                {
                                    id: 66,
                                    name: "Large",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 72,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/27574/fd36f4b6-52e7-4d8a-ab55-f430af15323a.png",
                            order_by: 3,
                            sub_category: [],
                            name: "Cuttings",
                            hierarchy: [
                                {
                                    id: 72,
                                    name: "Cuttings",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 70,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/10089/82c7a87c-0ccc-4bbf-b5d5-e32ba6c05631.png",
                            order_by: 4,
                            sub_category: [],
                            name: "Cacti & Succulents",
                            hierarchy: [
                                {
                                    id: 70,
                                    name: "Cacti & Succulents",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 73,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/67018/28edeebc-3402-428e-921c-850b09afb1fb.png",
                            order_by: 5,
                            sub_category: [],
                            name: "Pots & Accessories",
                            hierarchy: [
                                {
                                    id: 73,
                                    name: "Pots & Accessories",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 75,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/38943/653a0f8d-eee6-4b8b-918d-1c9e720576c1.png",
                            order_by: 8,
                            sub_category: [],
                            name: "Unicorn (Rarer Plants)",
                            hierarchy: [
                                {
                                    id: 75,
                                    name: "Unicorn (Rarer Plants)",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 76,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/41769/dc1105f2-26be-4e21-b40e-88da631e7496.png",
                            order_by: 8,
                            sub_category: [],
                            name: "Climbers",
                            hierarchy: [
                                {
                                    id: 76,
                                    name: "Climbers",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 69,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/94603/2ccee3b6-9411-4389-842b-600713b6459f.png",
                            order_by: 9,
                            sub_category: [],
                            name: "Low Light",
                            hierarchy: [
                                {
                                    id: 69,
                                    name: "Low Light",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 77,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/wyldeplants/72936/cf235659-66e3-4589-b73c-70a41b1e1a49.png",
                            order_by: 10,
                            sub_category: [],
                            name: "Low Maintenance ",
                            hierarchy: [
                                {
                                    id: 77,
                                    name: "Low Maintenance ",
                                    level: 1
                                }, 
                            ]
                        }, 
                    ],
                    values: [
                        {
                            id: 234,
                            active: true,
                            name: "Yes"
                        }, 
                    ]
                }, 
            ],
            tags: [],
            rating_data: {
                rating_count_data: {
                    rating_1: 0,
                    rating_2: 0,
                    rating_3: 0,
                    rating_4: 0,
                    rating_5: 0
                },
                rating_average: 0,
                rating_count: 0,
                review_count: 0
            },
            schedules: [],
            variants: []
        },
        rating_data: {
            rating_count_data: {
                rating_1: 0,
                rating_2: 0,
                rating_3: 0,
                rating_4: 0,
                rating_5: 0
            },
            rating_average: 0,
            rating_count: 0,
            review_count: 0
        }
    },
    event: {
        listing: {
            id: 9860,
            account_id: 3378,
            list_price: {
                amount: 15,
                currency: "SGD",
                formatted: "S$15"
            },
            category_id: [
                3430
            ],
            currency_id: 22,
            offer_percent: 0,
            stock: 5,
            shipping_charges: {
                amount: 0,
                currency: "SGD",
                formatted: "S$0"
            },
            images: [
                _productconferenceJpg.default
            ],
            offer_price: {
                amount: 15,
                currency: "SGD",
                formatted: "S$15"
            },
            location: {
                city: "",
                state: "",
                country: "Singapore",
                locality: "Punggol",
                postcode: "828811",
                country_code: "sg",
                formatted_address: "Tebing Lane, Punggol, Northeast, 828811, Singapore"
            },
            type: "events",
            sold: false,
            active: true,
            status: 2,
            created_at: 1639662894,
            start_at: 1639662894,
            end_at: 1639662894,
            likes: 0,
            max_quantity: 20,
            account: {
                id: 3378,
                name: "Infiniti Kids",
                location: {
                    city: "",
                    state: "",
                    country: "Singapore",
                    locality: "Punggol",
                    postcode: "828811",
                    country_code: "sg",
                    formatted_address: "Tebing Lane, Punggol, Northeast, 828811, Singapore"
                },
                unique_name: "",
                description: "Infiniti Kids aims to inspire children to explore and discover their potential in areas such as sports, music, art and technology so that they become confident, competent and motivated to pursue their area of interest.",
                total_followers: 0,
                total_listings: 3,
                images: [
                    "https://tradly-paas.s3.amazonaws.com/images/classbubs/77393/64991909-0dcc-4478-89ed-d39b6e04dd21.JPG", 
                ],
                type: "accounts",
                active: true,
                status: 2,
                following: false,
                user: {
                    email_verified: true,
                    blocked: false,
                    id: "e9b6c46e-3976-45b9-8f6d-a6bf580dc49d",
                    first_name: "Infiniti",
                    last_name: "Kids",
                    profile_pic: "https://tradly-paas.s3.amazonaws.com/images/classbubs/35346/2a9043bf-b7a2-44b2-a3e5-5fa5c248046f.JPG",
                    email: "info@infinitikids.org",
                    mobile: "",
                    dial_code: "",
                    created_at: 1639277493,
                    updated_at: 1639628165
                },
                category_id: []
            },
            categories: [
                {
                    id: 3430,
                    parent: 0,
                    type: "listings",
                    active: true,
                    image_path: "https://tradly-paas.s3.amazonaws.com/images/classbubs/52855/61b996b9-ef34-45af-bbbe-e25ab3ee4dd2.png",
                    order_by: 13,
                    sub_category: [],
                    name: "Sports",
                    hierarchy: [
                        {
                            id: 3430,
                            name: "Sports",
                            level: 1
                        }, 
                    ]
                }, 
            ],
            distance: 0,
            in_cart: false,
            liked: false,
            title: "Tech2Design conference",
            description: "About educator: Infiniti Kids aims to inspire children to explore and discover their potential in areas such as sports, music, art and technology so that they become confident, competent and motivated to pursue their area of interest.\n\nAbout class: Run, Jump, Throw! Infiniti Kids Multi Sports class aims to promote and develop Physical Literacy in young children, to develop them to be confident, competent and motivated in physical activity.\nOur program:\n\n Takes them through a variety of sports to allow sampling and exploration for kids to find\nwhat they truly enjoy!\n Consists of activities such as obstacle courses, circuits, fun games and sport skill\npractice, developing their fitness, fundamental movement skills and basic sports skills to\nprepare them for future sporting activities.\n Builds confidence and develop values in your child through social interactions with the\ncoaches and other children.\n\nJoin us for a fun and sweaty time!\n\nAge group: 3-5\n\nLocation: 6 Tebing Lane, S(828835)",
            coordinates: {
                latitude: 1.3929445,
                longitude: 103.9152788
            },
            attributes: [
                {
                    id: 50,
                    type: "listings",
                    field_type: 2,
                    optional: false,
                    private: false,
                    active: true,
                    order_by: 0,
                    name: "Age Group",
                    categories: [
                        {
                            id: 3418,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/classbubs/76962/6ec255f7-1169-409e-9311-b9a5e47b3d27.png",
                            order_by: 1,
                            sub_category: [],
                            name: "Art",
                            hierarchy: [
                                {
                                    id: 3418,
                                    name: "Art",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 3419,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/classbubs/80711/51cc1265-bd77-487e-94b6-183c75ba61f8.png",
                            order_by: 2,
                            sub_category: [],
                            name: "Camps",
                            hierarchy: [
                                {
                                    id: 3419,
                                    name: "Camps",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 3421,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/classbubs/35304/7a752e63-d1ec-4a51-9d5f-6d32225ea8b6.png",
                            order_by: 4,
                            sub_category: [],
                            name: "Dance",
                            hierarchy: [
                                {
                                    id: 3421,
                                    name: "Dance",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 3422,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/classbubs/72463/4d73986c-a74f-4aaa-9380-3f567790ca05.png",
                            order_by: 5,
                            sub_category: [],
                            name: "Language",
                            hierarchy: [
                                {
                                    id: 3422,
                                    name: "Language",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 3423,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/classbubs/10946/ad3d99b6-335f-4c56-996e-abaa30e3a470.png",
                            order_by: 6,
                            sub_category: [],
                            name: "Life Skills",
                            hierarchy: [
                                {
                                    id: 3423,
                                    name: "Life Skills",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 3424,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/classbubs/50503/106fe09c-bb92-4a58-a368-a7b40f5fd87e.png",
                            order_by: 7,
                            sub_category: [],
                            name: "Music",
                            hierarchy: [
                                {
                                    id: 3424,
                                    name: "Music",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 3425,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/classbubs/71243/4fd02399-c768-48ce-bba4-e94af53e1454.png",
                            order_by: 8,
                            sub_category: [],
                            name: "Online Classes",
                            hierarchy: [
                                {
                                    id: 3425,
                                    name: "Online Classes",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 3426,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/classbubs/67000/a7dd0a0d-c797-4c1c-b546-039c181a4df3.png",
                            order_by: 9,
                            sub_category: [],
                            name: "Outdoors",
                            hierarchy: [
                                {
                                    id: 3426,
                                    name: "Outdoors",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 3427,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/classbubs/25051/45efe60e-dff2-459e-b236-c04ec59d0698.png",
                            order_by: 10,
                            sub_category: [],
                            name: "Parent Accompanied",
                            hierarchy: [
                                {
                                    id: 3427,
                                    name: "Parent Accompanied",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 3428,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/classbubs/24696/2bbd717d-57ba-442e-9faa-b4328d844945.png",
                            order_by: 11,
                            sub_category: [],
                            name: "Play",
                            hierarchy: [
                                {
                                    id: 3428,
                                    name: "Play",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 3429,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/classbubs/72451/cda6a782-4348-4d85-8dcc-c8752ef5dfe6.png",
                            order_by: 12,
                            sub_category: [],
                            name: "Special Workshops",
                            hierarchy: [
                                {
                                    id: 3429,
                                    name: "Special Workshops",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 3430,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/classbubs/52855/61b996b9-ef34-45af-bbbe-e25ab3ee4dd2.png",
                            order_by: 13,
                            sub_category: [],
                            name: "Sports",
                            hierarchy: [
                                {
                                    id: 3430,
                                    name: "Sports",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 3431,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/classbubs/58218/c6e2233c-98c7-4d00-bc55-1eb09f20a072.png",
                            order_by: 14,
                            sub_category: [],
                            name: "Technology",
                            hierarchy: [
                                {
                                    id: 3431,
                                    name: "Technology",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 3432,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/classbubs/65971/d466ae0e-6e5e-4ad5-b788-9923b53476e0.png",
                            order_by: 15,
                            sub_category: [],
                            name: "Theatre",
                            hierarchy: [
                                {
                                    id: 3432,
                                    name: "Theatre",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 3433,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/classbubs/95220/b9c31edc-34fc-4e62-b595-e81ce76e3dca.png",
                            order_by: 16,
                            sub_category: [],
                            name: "Wellness",
                            hierarchy: [
                                {
                                    id: 3433,
                                    name: "Wellness",
                                    level: 1
                                }, 
                            ]
                        },
                        {
                            id: 3434,
                            parent: 0,
                            type: "listings",
                            active: true,
                            image_path: "https://tradly-paas.s3.amazonaws.com/images/classbubs/20491/021c0d5d-4505-45b3-8cb9-5ab80df101ca.png",
                            order_by: 17,
                            sub_category: [],
                            name: "Workshops for Parents",
                            hierarchy: [
                                {
                                    id: 3434,
                                    name: "Workshops for Parents",
                                    level: 1
                                }, 
                            ]
                        }, 
                    ],
                    values: [
                        {
                            id: 192,
                            active: true,
                            name: "3-5 years old"
                        }, 
                    ]
                }, 
            ],
            tags: [],
            rating_data: {
                rating_count_data: {
                    rating_1: 0,
                    rating_2: 0,
                    rating_3: 0,
                    rating_4: 0,
                    rating_5: 0
                },
                rating_average: 0,
                rating_count: 0,
                review_count: 0
            },
            schedules: [
                {
                    active: true,
                    start_date: "2021-12-16",
                    start_time: "01:45",
                    end_time: "14:30",
                    repeat_days: [
                        7
                    ],
                    schedule_type: 2
                }, 
            ],
            variants: [
                {
                    id: 97,
                    list_price: {
                        amount: 15,
                        currency: "SGD",
                        formatted: "S$15"
                    },
                    offer_percent: 0,
                    images: [
                        _nordicDesignJpg.default
                    ],
                    offer_price: {
                        amount: 15,
                        currency: "SGD",
                        formatted: "S$15"
                    },
                    active: true,
                    stock: 1,
                    max_quantity: 0,
                    created_at: 1639662896,
                    updated_at: 1639662896,
                    title: "Product Design ",
                    description: "About educator: Infiniti Kids aims to inspire children to explore and discover their potential in areas such as sports, music, art and technology so that they become confident, competent and motivated to pursue their area of interest.\n\nAbout class: Run, Jump, Throw! Infiniti Kids Multi Sports class aims to promote and develop Physical Literacy in young children, to develop them to be confident, competent and motivated in physical activity.\nOur program:\n\n Takes them through a variety of sports to allow sampling and exploration for kids to find\nwhat they truly enjoy!\n Consists of activities such as obstacle courses, circuits, fun games and sport skill\npractice, developing their fitness, fundamental movement skills and basic sports skills to\nprepare them for future sporting activities.\n Builds confidence and develop values in your child through social interactions with the\ncoaches and other children.\n\nJoin us for a fun and sweaty time!\n\nAge group: 3-5\n\nLocation: 6 Tebing Lane, S(828835)",
                    variant_values: [
                        {
                            variant_type_id: 1,
                            variant_type_value_id: 1,
                            variant_type: {
                                id: 1,
                                name: "Ticket Type"
                            },
                            variant_type_value: {
                                id: 1,
                                name: "Trial Class"
                            }
                        }, 
                    ]
                }, 
            ]
        },
        rating_data: {
            rating_count_data: {
                rating_1: 0,
                rating_2: 0,
                rating_3: 0,
                rating_4: 0,
                rating_5: 0
            },
            rating_average: 0,
            rating_count: 0,
            review_count: 0
        }
    },
    group: [
        {
            name: "Turkish Farmers",
            member: 700,
            img: _turkishDriedFruitsJpeg.default
        },
        {
            name: "Yemen Retailers",
            member: 600,
            img: _yemenCoffeeJpeg.default
        },
        {
            name: "Dutch Farmers ",
            member: 500,
            img: _organicAfricaSVegJpg.default
        },
        {
            name: "Nordic Farmers",
            member: 600,
            img: _nordicFlowersJpeg.default
        }, 
    ]
};


/***/ })

}]);